const fr = {
  // common
  'Loading...': 'Chargement en cours...',
  'No data': 'Aucune donnée',
  Yes: 'Oui',
  No: 'Non',
  Imperial: 'Impérial',
  Metric: 'Métrique',
  Bar: 'bar',
  bar: 'bar',
  'm^3/min': 'm^3/min',
  'm3/min': 'm<0>3</0>/min',
  kW: 'kW',
  'SPECIFIC POWER': 'PUISSANCE SPÉCIFIQUE',
  pressure: 'Pression',
  'operation mode': 'Mode de fonctionnement',
  flow: 'flux',
  power: 'Puissance',
  PSI: 'psi',
  psi: 'psi',
  CFM: 'CFM',
  cfm: 'cfm',
  RPM: 'TR-MIN',
  temperature: 'température',
  Temperature: 'Température',
  Celsius: 'Celsius',
  celsius: 'celsius',
  Fahrenheit: 'Fahrenheit',
  fahrenheit: 'fahrenheit',
  '°C': '°C',
  '°F': '°F',
  current: 'actuel',
  'Oil temperature': "Température de l'huile",
  'Dew point temperature': 'Température de point de rosée',
  'Inverter speed': "Vitesse d'inverseur",
  'Run hours': 'Heures de fonctionnement',
  'Load hours': 'Heures de chargement',
  '_ _': '_ _',
  'N/A': 'N/A',
  'Water Flow': "Débit d'eau",
  'Inlet Water Temperature': "Température de d'entrée d'eau",
  'Outlet Water Temperature': "Température de sortie d'eau",

  // login page
  'Welcome to EcoPlant': 'Bienvenue chez EcoPlant',
  'For technical support email us at:':
    "Pour obtenir une assistance technique, envoyez-nous un e-mail à l'adresse suivante:",
  'EcoPlant 2020. All right reserved.': 'EcoPlant 2020. Tous droits réservés.',
  'Email Address': 'Adresse e-mail',
  Password: 'Mot de passe',
  Login: 'Se connecter',
  'Enter a verification code': 'Entrez un code de vérification',
  'Send Again': 'Envoyer à nouveau',
  Done: 'Terminé',
  Cancel: 'Annuler',
  'SMS with a verification code was sent to your phone':
    'Un SMS contenant un code de vérification a été envoyé sur votre téléphone',
  'Forgot Password': 'Mot de passe oublié',
  'Sign in with Single Sign On': 'Connectez-vous avec Single Sign On',

  // side menu
  "Eco plant's logo": 'Logo de Ecoplant',
  'Log out': 'Déconnectez-vous',

  // eco score card
  'ECO RATING': 'Note ÉCO',
  'Specific power': 'Puissance spécifique',
  'kW/(m^3/min)': 'kW/ (m^3/min)',
  'kW/(m3/min)': 'kW/(m<0>3</0>/min)',
  'm^3': 'm<0>3</0>',
  'ft^3': 'ft<0>3</0>',
  'kW/100CFM': 'kW/100CFM',

  // alerts
  ALERTS: 'ALERTES',
  All: 'Tous',
  Service: 'Service',
  service: 'service',
  Warning: 'Avertissement',
  warning: 'avertissement',
  Shutdown: 'Arrêt',
  shutdown: 'arrêt',
  Expired: 'Expiré',
  Custom: 'Personnaliser',
  Manufacturer: 'Fabricant',
  'No more alerts to show': 'Plus aucune alerte à afficher',
  'No alerts to show for this severity type.': 'Aucune alerte à afficher pour ce type de gravité.',
  RECOMMENDATION: 'RECOMMANDATION',
  'No archived alerts yet.': 'Aucune alerte archivée pour le moment.',
  'Or contact us via:': 'Ou contactez-nous via:',
  noAlertsToShow: "Aucune alerte à afficher. Vous pouvez consulter les anciennes alertes sous l'onglet <1>Archive</1>.",
  'Archive Alert': "Alerte d'archivage",
  'Unarchive alert failed': "L'alerte de désarchivage a échoué",
  "View Alert record's rule (logic)": "Afficher la règle de l'enregistrement d'alerte (logique)",
  'Auto & manually archived alerts': 'Alertes automatiquement archivées & manuellement',
  'Received during maintenance': 'Reçu pendant la maintenance',
  'This alert record was triggered while the compressor was In-Maintenance':
    "Cet enregistrement d'alerte a été déclenché alors que le compresseur était en maintenance",
  SSOLoginNotEnabled:
    "Votre organisation n'a pas activé la connexion SSO pour votre adresse e-mail. Veuillez utiliser plutôt la méthode d'authentification par mot de passe",
  LoginFailureNoStations:
    'Votre tentative de connexion a échoué, car aucune station n’est actuellement assignée à votre compte. Veuillez contacter votre administrateur informatique pour demander l’accès aux stations requises.',
  LoginFailurePasswordError:
    'Votre tentative de connexion a échoué. Erreur système : {{error}} si votre entreprise utilise l’authentification unique (SSO), essayez de vous connecter en utilisant cette option.',
  LoginFailureUnhautorizedSSO:
    "Votre tentative de connexion a échoué car votre compte SSO n'est pas autorisé. Veuillez essayer de vous connecter avec un autre compte SSO ou utiliser l'option de connexion par mot de passe.",
  'Are you sure you want to unarchive this alert record?':
    "Êtes-vous sûr de vouloir désarchiver cet enregistrement d'alerte?",

  // main
  Map: 'Carte',
  Trends: 'Tendances',
  Investigation: 'Analyse',
  'Reset zoom': 'Réinitialiser le zoom',
  VALUE: 'valeur',
  PLANT: 'usine',
  REPORTS: 'rapports',
  ENGINE: 'algorithme',

  // MapKPI
  'Value may depend on multiple sensors and average values over time.':
    'La valeur peut dépendre de plusieurs capteurs et des valeurs moyennes au fil du temps.',
  moreDetailsInStationControl: "Pour plus de détails, consultez l'onglet Station Control Center",
  moreDetailsInValueDashboard: "Voir plus de détails sur l'écran Value Dashboard",
  'Compressor kW based calculation': 'Calcul de la puissance du compresseur basée sur le débit',
  'Flow based on Flow sensor avg at the end of the station':
    'Débit basé sur la moyenne du capteur de débit à la fin de la station',
  'Pressure Drop': 'Chute de pression',

  // Trends
  UTC: 'UTC',
  Yesterday: 'Hier',
  'Last 24 hours': 'Les dernières 24 heures',
  'Last 7 days': 'Les 7 derniers jours',
  'Last 30 days': 'Les 30 derniers jours',
  'Last 90 days': 'Les 90 derniers jours',

  Pressure: 'Pression',
  Flow: 'Débit',
  Power: 'Puissance',
  'Specific Power': 'Puissance spécifique',
  'specific power': 'puissance spécifique',
  'Oil temp': "Température d'huile",
  'Dew temp': 'Point de rosée',

  // trends - tooltip
  second: 'seconde',
  seconds: 'secondes',
  minute: 'minute',
  minutes: 'minutes',
  hour: 'heure',
  hours: 'heures',
  day: 'jour',
  week: 'semaine',
  month: 'mois',
  '{{value}} {{unit}} average': '{{value}} {{unit}} moyenne',

  // device modal
  Run: 'Marche',
  Load: 'En charge',
  LOAD: 'En charge',
  Unload: 'À vide',
  UNLOAD: 'À vide',
  Off: 'Arrêt',
  OFF: 'Arrêt',
  ON: 'Marche',
  On: 'Marche',
  Loading: 'Mise en charge',
  Unloading: 'Mise à vide',
  Disconnected: 'Déconnecté',
  disconnected: 'Déconnecté',
  'No State': 'Aucun État',
  NoState: 'Aucun État',
  NO_STATE: 'aucun état',
  capacity: 'capacité',
  Liter: 'Litre',
  liter: 'litre',
  Gallon: 'Gallon',
  gallon: 'gallon',
  'pipe diameter': 'diamètre du tuyau',
  'pipe material': 'matériau du tuyau',
  inch: 'pouce',
  mm: 'mm',
  'dew point temperature': 'température de point de rosée',
  activity: 'activité',

  STOPPED: 'Stoppé',
  Connected: 'Connecté',
  connected: 'Connecté',
  'Not connected': 'Non connecté',
  connectivity: 'Connectivité',
  CONNECTION_ERROR: 'erreur de connexion',

  Auto: 'Auto',
  Manual: 'Manuel',
  Controllable: 'Contrôlable',
  CONTROLLABLE: 'Contrôlable',
  ON_OFF: 'Marche/Arrêt',
  NOTCONTROLLABLE: 'Non contrôlable',
  NOT_CONTROLLABLE: 'Non contrôlable',
  'On/Off': 'Activé/Désactivé',
  'Not controllable': 'Non contrôlable',
  'Min set point': 'Point de réglage minimum',
  'Max set point': 'Point de réglage maximal',
  VSD_TARGET: 'Cible VSD',
  NEXT_SERVICE_IN: 'prochain service dans',
  NEXT_SERVICE_TYPE: 'type de service suivant',
  h: 'h',
  Min: 'Min',
  WORKING_HOURS: 'heures de travail',
  HORSE_POWER: 'puissance en chevaux',
  'control mode': 'Mode de contrôle',

  'filter type': 'type de filtre',
  'last service': 'dernier service',
  CYCLE: 'CYCLE',
  DUTY: 'DEVOIR',
  'Sensor Based': 'Basé sur un capteur',
  'Compressor Estimation': 'Estimation du compresseur',
  'kW Based Calculation': 'Calcul basé sur le kW',
  'AI Calculation': "Calcul de l'IA",
  'RELATIVE POSITION': 'POSITION RELATIVE',
  'back indication': 'indication arrière',
  'last command': 'dernière commande',
  'default state': 'état par défaut',
  Open: 'Ouvrir',
  'Last set point': 'Dernier point de consigne',
  'I/O': 'E/S',
  'relative position': 'Position relative',
  pressureSetpoints: 'Points de consigne',
  hp: 'HP',
  lp: 'LP',
  lowLimit: 'Limite basse',
  targetSetpoint: 'Point de consigne',
  // node factory
  Filter: 'Filtre',
  Valve: 'Soupape',
  INLET_VALVE: 'vanne IV',
  BYPASS_VALVE: 'vanne BV',
  CLOSE: 'fermer',
  OPEN: 'ouvrir',
  'Closed Valve - Connected': 'Vanne fermée - Connectée',
  'Open Valve - Connected': 'Valve ouverte - Connectée',
  'Valve state not found': 'État de la vanne introuvable',
  'Valve - Disconnected': 'Valve - Déconnectée',
  Booster: 'Surpresseur',
  Compressor: 'Compresseur',
  HP: 'HP',

  'Desiccant Air Dryer': "Sécheur d'air adsorption",
  Desiccant: 'Adsorption',
  drying: 'Séchage',
  refrigerating: 'Réfrigération',
  waterPressureSensor: "Capteur de pression d'eau",
  'dew point': 'Point de rosée',
  DEW_POINT: 'point de rosée',
  timer: 'Minuteur',
  energySaving: "économie d'énergie",
  ENERGY_SAVINGS: "économies d'énergie",
  'Dew Point Sensor': 'Capteur de point de rosée',
  'Dry Air Tank': "Réservoir d'air sec",
  Dry: 'Sec',
  'Combo Sensor': 'Capteur Combo',
  'Flow Sensor': 'Capteur de débit',
  'Pressure Sensor': 'Capteur de pression',
  'Production Floor': 'Salle de production',
  'Refrigerated Air Dryer': "Sécheur d'air frigo",
  Refrigerated: 'Réfrigéré',
  'Wet Air Tank': "Réservoir d'air humide",
  Wet: 'Humide',
  Maintenance: 'Entretien',

  fixedSpeed: 'Compresseur à vitesse fixe',
  variableSpeedDrive: 'Compresseur à vitesse variable',
  centrifugal: 'Compresseur centrifuge',
  fixedSpeed_powerSensor: '$t(fixedSpeed)',
  powerSensor_variableSpeedDrive: '$t(variableSpeedDrive)',
  centrifugal_powerSensor: '$t(centrifugal)',
  booster: '$t(Booster)',
  wetAirTank: '$t(Wet Air Tank)',
  dryAirTank: '$t(Dry Air Tank)',
  desiccantAirDryer: '$t(Desiccant Air Dryer)',
  refrigeratedAirDryer: '$t(Refrigerated Air Dryer)',
  pressureSensor: '$t(Pressure Sensor)',
  flowSensor: '$t(Flow Sensor)',
  flowSensor_pressureSensor: 'Capteur de débit et de pression',
  dewpointSensor: '$t(Dew Point Sensor)',
  dewpointSensor_pressureSensor: 'Capteur de point de rosée et de pression',
  ambientHumiditySensor_ambientTemperatureSensor: "Capteur d'humidité et de température ambiantes",
  ambientHumiditySensor_ambientTemperatureSensor_dewpointSensor:
    "Capteur d'humidité ambiante, de température et de point de rosée",
  airTemperatureSensor: '$t(AIR_TEMPERATURE_SENSOR)',
  airFilter: '$t(Filter)',
  proportionalValve: 'Vanne proportionnelle',
  openCloseValve: 'Ouvrir/fermer la vanne',
  spillValve: 'Vanne de déverse',
  productionFloor: '$t(Production Floor)',

  // alert rules
  'The logic triggering alerts': 'La logique qui déclenche les alertes',
  'Alert rules management': "Gestion des règles d'alerte",
  'My rules': 'Mes règles',
  'No rules to display': 'Aucune règle à afficher',
  'Rule condition:': 'Condition de règle:',
  and: 'et',
  or: 'ou',
  of: 'de',
  is: 'est',
  greaterThan: 'supérieur à',
  equalTo: 'égal à',
  notEqualTo: 'pas égal à',
  greaterThanOrEqualTo: 'supérieur ou égal à',
  lessThan: 'inférieur à',
  lessThanOrEqualTo: 'inférieur ou égal à',
  'Filter by source': 'Filtrer par source',
  'Filter by device': 'Filtrer par appareil',
  'Create new rule': 'Créer une nouvelle règle',
  'Rule activation status': "État d'activation des règles",
  Severity: 'Gravité',
  'Date created': 'Date de création',
  'Last updated': 'Dernière mise à jour',
  'Are you sure you want to start monitoring and alerting on this type of events?':
    "Êtes-vous sûr de vouloir commencer à surveiller et à émettre des alertes sur ce type d'événements?",
  'Are you sure you want to stop monitoring and alerting on this type of events?':
    "Êtes-vous sûr de vouloir arrêter la surveillance et les alertes sur ce type d'événements?",
  'Failed to change activation status': "Impossible de modifier le statut d'activation",
  'Are you sure you want to delete this rule?': 'Êtes-vous sûr de vouloir supprimer cette règle?',
  'Failed to delete rule': 'Impossible de supprimer la règle',
  'This alert rule has changed since the record you clicked on. The last change was on':
    "Cette règle d'alerte a changé depuis l'enregistrement sur lequel vous avez cliqué. Le dernier changement a été effectué",
  'This alert rule has been deleted': "Cette règle d'alerte a été supprimée",
  'You can only turn this alert rule off.': "Vous pouvez uniquement désactiver cette règle d'alerte.",
  'To modify please contact your system administrator or the Ecoplant support':
    'Pour modifier, veuillez contacter votre administrateur système ou le support Ecoplant',
  'New Alert': 'Nouvelle alerte',

  // create edit rule
  Update: 'Mettre à jour',
  Create: 'Créer',
  'Create and Activate': 'Création et activation',
  'Update a custom rule': 'Mettre à jour une règle personnalisée',
  'Create a custom rule': "Création d'une règle personnalisée",
  'Name the alerts and set their severity.': 'Nommez les alertes et définissez leur gravité.',
  'Define the logic for triggering alerts of different severity levels.':
    "Définissez la logique de déclenchement d'alertes de différents niveaux de gravité.",
  'E.g. High than usual flow causes pressure drop':
    "Par exemple Un débit plus élevé que d'habitude entraîne une chute de pression",
  Description: 'Descriptif',
  'E.g. Try do the following...': 'Par exemple Essayez de faire ce qui suit...',
  'Alert severity': 'Gravité des alertes',
  'Rule name (Title)': 'Nom de la règle (Titre)',
  'Duration (if this rule lasts for x time)': 'Durée (si cette règle dure x fois)',
  Immediately: 'Immédiatement',
  'Choose the parameter you wish to monitor.': 'Choisissez le paramètre que vous souhaitez contrôler.',
  Parameter: 'Paramètre',
  'Choose a device with the above-selected monitored parameter. Select multiple devices to create a rule on a calculated parameter (e.g. Pressure difference between devices).':
    'Choisissez un appareil avec le paramètre surveillé sélectionné ci-dessus. Sélectionnez plusieurs appareils pour créer une règle sur un paramètre calculé (par exemple, différence de pression entre appareils).',
  'Choose the operand and the target value threshold to trigger the alerts.':
    "Choisissez l'opérande et le seuil de valeur cible pour déclencher les alertes.",
  Operand: 'Opérande',
  'Target value': 'Valeur cible',
  'Save and activate to start monitoring the parameter and trigger alerts according to the rule.':
    'Enregistrez et activez pour commencer à surveiller le paramètre et déclencher des alertes conformément à la règle.',
  'Contact us if you have any questions at:': "Contactez-nous si vous avez des questions à l'adresse suivante:",
  'Add device': 'Ajouter un appareil',
  'E.g. 6.4': 'Par exemple 6,4',
  'Alert rule updated successfully': "Règle d'alerte mise à jour avec succès",
  'Alert rule created successfully': "Règle d'alerte créée avec succès",
  'Follow the math order of operations.': "Suivez l'ordre mathématique des opérations.",
  'You dont have enough permission to create an alert, please contact your administrator.':
    "Vous n'avez pas les autorisations nécessaires pour créer une alerte, contactez votre administrateur.",
  'Update manufacturer alert rule': "Mettre à jour la règle d'alerte du fabricant",
  'Edit this Alert rule appearance': "Modifier l'apparence de cette règle d'alerte",
  'Alert rule original details': "Détails d'origine de la règle d'alerte",
  'Original rule name (Title)': "Nom de la règle d'origine (Titre)",
  'Given rule name (Title)': 'Nom de la règle donné (Titre)',
  'E.g. High then usual flow causes pressure drop':
    'Par exemple Un débit élevé par rapport à la normale entraîne une chute de pression',
  'Original description': 'Description originale',
  'Given description': 'Description donnée',
  'Device name': "Nom de l'appareil",
  'Alert rule ID': "ID de règle d'alerte",
  'Creation date': 'Date de création',

  //error modal
  'Something went wrong': "Quelque chose s'est mal passé",
  'Please try again later.': 'Veuillez réessayer ultérieurement.',
  Dismiss: 'Rejeter',

  //Proactive engine (dynamic controller)
  'Dynamic Controller': 'Contrôleur dynamique',
  'Controller Mode': 'Mode contrôleur',
  Activated: 'Activé',
  Deactivated: 'Désactivé',
  Unavailable: 'Indisponible',
  Unknown: 'Inconnu',
  'Dynamic Controller is Activated': 'Le contrôleur dynamique est activé',
  'Dynamic Controller is Deactivated': 'Le contrôleur dynamique est désactivé',
  'Dynamic Controller is Disabled - Under Maintenance':
    'Le contrôleur dynamique est désactivé - En cours de maintenance',
  'Dynamic Controller is Disabled by Local Control Switch':
    'Le contrôleur dynamique est désactivé par le commutateur de commande local',
  'Dynamic Controller is Disabled by Cloud Control Switch':
    'Le contrôleur dynamique est désactivé par Cloud Control Switch',
  leakMeasurementNear: 'Mesure des fuites en une semaine',
  leakMeasurementOnGoing: 'La mesure des fuites est en cours',
  leakMeasurementInDays: 'Mesure des fuites prévue dans {{count}} jours',
  'Are you sure?': 'Êtes-vous sûr ?',
  FailedToActivateDynamicController: "Impossible d'activer le contrôleur dynamique",
  FailedToDeactivateDynamicController: 'Impossible de désactiver le contrôleur dynamique',
  CompressorInMaintenancePreventsActivation:
    'Le contrôleur dynamique ne peut pas être activé car les compresseurs sont en maintenance ou leur priorité est ignorée',

  // No Flow Control Notification Modal
  noFlowControlNotificationTitle: 'Le Contrôle Dynamique pour cette station a été mis à jour.',
  noFlowControlNotificationSubtitle:
    'Nous utilisons maintenant le débit estimé ("pas de débit") au lieu du contrôle par capteur de débit. Par conséquent:',
  noFlowControlKpisRecalculated:
    'Les KPI de Débit et de Puissance Spécifique sont recalculés, les valeurs peuvent donc changer.',
  noFlowControlSavingsAdjusted: 'Les économies sont ajustées en utilisant la même puissance spécifique de référence.',
  noFlowControlSensorsDifferent:
    "Les capteurs de débit affichent toujours les lectures, mais ils n'affectent plus les KPI et apparaissent différemment sur la carte.",
  noFlowControlHistoricalKpis: "Les KPI historiques des capteurs de débit restent disponibles jusqu'au changement.",
  noFlowControlClosingMessage:
    'Cette mise à jour aide à assurer un contrôle fluide et des performances constantes. Profitez de la mise à jour !',
  noFlowControlOkButton: 'OK, compris !',

  'Last commands': 'Dernières commandes',
  Device: 'Appareil',
  'New Value': 'Nouvelle valeur',
  User: 'Utilisateur',
  Status: 'État',
  Reason: 'Motif',
  'Date Created': 'Date de création',
  'No commands to show': 'Aucune commande à afficher',
  'Load more': 'Charger davantage',
  'Waiting For Deliver': 'En attente de retour',
  'Received And Updated': 'Reçu et mis à jour',
  'Failed To Update': 'Impossible de mettre à jour',
  'Failed TimeOut': "Échec du délai d'attente",
  'Failed Offline': 'Échec hors ligne',
  'Ignored Unchanged Value': 'Valeur inchangée ignorée',

  //Investigation dashboard
  'Investigate by Devices': 'Mener des enquêtes sur chaque appareils',
  'Show me (from-to)': 'Présentez-moi ( depuis-à )',
  'Compare with (Show me from-to)': 'Faites une comparaison avec ( Présentez-moi depuis-à )',
  'You can choose up to 10 parameters per time period. When comparing 2 time periods, you can choose up to 5 parameters.':
    "Vous pouvez choisir jusqu'à 10 paramètres par période. Lorsque vous comparez 2 périodes, vous pouvez choisir jusqu'à 5 paramètres.",
  'When comparing 2 time periods, you can choose up to 5 parameters.':
    "Lorsque vous comparez 2 périodes, vous pouvez choisir jusqu'à 5 paramètres.",
  'Choose only Power parameters to view the Stack layout. You cannot choose the station total power':
    'Choisissez uniquement les paramètres Power pour afficher la disposition de la pile. Vous ne pouvez pas choisir la puissance totale de la station',
  'Station KPIs': 'KPI de la station',
  'Periods compare': 'Comparaison des périodes',
  'Pressure drop': 'Chute de pression',
  'Please choose a time period and at least one parameter.': 'Choisissez une période et au moins un paramètre.',
  'No data to show for this time frame and parameters.':
    'Aucune donnée à afficher pour cette période et ces paramètres.',
  'Please choose at least one graph.': 'Veuillez sélectionner au moins un graphique.',
  'Left mouse to zoom': 'Souris gauche pour zoomer',
  'Alt + Left mouse to pan': 'Alt + gauche de la souris pour effectuer un panoramique',
  minuteAverageWithCount: '{{count}} minutes en moyenne',
  minuteAverageWithCount_plural: '{{count}} minutes en moyenne',
  hourAverageWithCount: '{{count}} heures en moyenne',
  hourAverageWithCount_plural: '{{count}} heures en moyenne',
  'Sensor based': 'Basé sur un capteur',
  'Comp. Est.': 'Comp. Est.',
  'kW Calc. Based': 'kW Calc. Base',
  'AI Calc.': 'AI Calc.',
  'kW based calculation': 'calcul basé sur le kW',
  Tabular: 'Tabulaire',
  'Alerts Record List': "Liste des enregistrements d'alertes",
  'Alert Record': 'Enregistrement des alertes',
  Source: 'La Source',
  'Date Fired': 'Date de licenciement',
  'Displayed alerts': 'Alertes affichées',
  Archived: 'Archivé',
  'Time period': 'Période',
  restAlerts: '... et {{restAlertsCount}} autres alertes',
  total: 'Total',
  compareTwoTimePeriods: 'Comparez 2 périodes',
  none: 'Aucune',
  showInDeviceStatus: "Afficher l'état de l'appareil",
  maintenance: 'Entretien',
  'n/a': 'N/A',
  devicesStatus: 'État des appareils',
  dynamicControl: 'Contrôle dynamique',
  optimize: 'OPTIMISER',
  now: 'Maintenant',

  //Data export
  'Report export': 'Exportation de rapports',
  'Report export preferences': "Préférences d'exportation des rapports",
  'This file will be downloaded as a .csv': 'Ce fichier sera téléchargé au format .csv',
  'Time presentation interval': "Intervalle de présentation de l'heure",
  'Time zone': 'Fuseau horaire',
  'Unit system': "Système d'unités",
  Export: 'Exporter',
  'Report contains to many records': "Le rapport contient trop d'enregistrements",
  'Another export is already in progress': 'Une autre exportation est déjà en cours',
  VS: 'CONTRE',
  'Data export failed': "L'exportation des données a échoué",
  'While your file is being prepared do not refresh or close this tab':
    "Pendant la préparation de votre fichier, n'actualisez pas et ne fermez pas cet onglet",
  'Something went wrong. Make sure you generated a valid report in the investigation tab':
    "Quelque chose s'est mal passé. Assurez-vous d'avoir généré un rapport valide dans l'onglet Investigation",

  //Station control center
  'Station Control Center': 'Centre de contrôle de la station',
  TARGET: 'CIBLE',
  MAINTENANCE: 'ENTRETIEN',
  OPERATION: 'OPÉRATION',
  'Failed changing maintenance mode': 'Échec du changement de mode de maintenance',
  SCC: 'SCC',
  'You are about to modify the control of the dynamic controller. Are you sure?':
    'Vous êtes sur le point de modifier le contrôle du contrôleur dynamique. Êtes-vous sûr ?',
  setpointsSetTo: 'Les valeurs de consigne seront définies comme suit: ',
  noneSetpoints: 'Derniers points de consigne configurés',
  baselineSetpoints: 'Points de consigne de référence',
  customSetpoints: 'Points de consigne personnalisés',
  contactCustomerSuccessManager: 'Contactez votre Customer Success Manager pour modifier ce comportement',

  /// Power toggle tooltips
  'Changes can be made in Station Control Center only.':
    'Les modifications ne peuvent être apportées que dans le centre de contrôle de la station.',
  'Turn compressor on verification': "Vous êtes sur le point d'activer {{name}}. Êtes-vous sûr ?",
  'Turn compressor off verification': 'Vous êtes sur le point de désactiver {{name}}. Êtes-vous sûr ?',
  'Function is disabled since Engine Mode is Activated': 'La fonction est désactivée car le mode moteur est activé',
  'Function is disabled since changing power state is not supported on this compressor.':
    "La fonction est désactivée car le changement d'état d'alimentation n'est pas pris en charge sur ce compresseur.",
  'Waiting for state to change.': "En attente d'un changement d'état.",
  'You are not allowed to change power state for devices.':
    "Vous n'êtes pas autorisé à modifier l'état d'alimentation des appareils.",
  'Are you sure you want to mark this device as In maintenance?':
    'Êtes-vous sûr de vouloir marquer cet appareil comme étant en cours de maintenance?',
  'Are you sure you want to mark this device as not in maintenance?':
    "Êtes-vous sûr de vouloir marquer cet appareil comme n'étant pas en maintenance?",
  goingToMaintenanceMessage:
    'La configuration de tous les compresseurs en maintenance désactivera le contrôle dynamique. Êtes-vous sûr ?',
  CHANGE_COMPRESSOR_STATE_FAILED: "Impossible de modifier l'état d'alimentation du compresseur {{deviceName}}",
  Start: 'Démarrer',
  Stop: 'Arrêter',

  //P&ID Draft
  'P&ID Draft': 'Brouillons des schémas P&ID',
  'Last updated on:': 'Dernière mise à jour le:',
  'Refresh Map': 'Actualiser la carte',
  'Station Draft': 'Brouillon de station',

  //Value Dashboard
  SHOWING_CURRENT_MONTH_ACCUMULATED_DATA: 'Affichage des données cumulées du mois en cours',
  Energy: 'Énergie',
  Volume: 'Volume',
  'Energy Efficiency': 'Efficacité énergétique',
  'Energy Saving': "Économie d'énergie",
  Baseline: 'Point de référence',
  'Actual Energy': 'Énergie réelle',
  'Specific Power Baseline': 'Période de référence de puissance spécifique',
  'Maintenance Event': 'Événement de maintenance',
  'Baseline Period': 'Période de référence:',
  To: 'À',
  DAY: 'JOUR',
  MTD: 'MTD',
  YTD: 'YTD',
  YEAR: 'ANNÉE',
  MONTH: 'MOIS',
  AVG: 'MOYENNE',
  MT: 'MT',
  GHG: 'GHG',
  energySavingsOpportunity: "Opportunité d'économies d'énergie",
  'MONTH AVG': 'MOYENNE MOIS',
  'YEAR TOTAL': "TOTAL DE L'ANNÉE",
  '5-YEAR PROJECTION REDUCTION': 'RÉDUCTION DES PROJECTIONS SUR 5 ANS',
  // Leakage
  leakage: 'Fuite',
  overview: "Vue d'ensemble",
  segmentation: 'Répartition des mesures',
  timeline: 'Journal des mesures',
  // Overview tab
  lastLeakageMeasure: "Estimation des fuites d'air par rapport à {{month}} {{year}}",
  previous: 'Précédent',
  lifetime: 'DURÉE DE VIE',
  lifeTimeLocalization: 'Durée de vie',
  actionTaken: 'Action Entreprise',
  wasted: 'Gaspillé',
  lastMeasureDate: 'Dernière mesure de fuite',
  nextPeriodicShutdown: 'Arrêt suivant',
  add: 'Ajouter',
  setAnAudit: "Définir une période d'audit",
  dailyFlowTooltip: 'Débit moyen quotidien du mois précédent',
  kwLeakRateSliderTooltip: 'Consommation électrique estimée lors du dernier arrêt périodique',
  ytdTooltip: 'Les données sont mises à jour tous les mois',
  ok: 'OK',
  clear: 'Effacer',
  nextPeriodicShutdownPopconfirm1:
    "Un brouillon de la période de fuite a été créé. Il ne sera affiché ici qu'après approbation par l'expert Ecoplant.",
  nextPeriodicShutdownPopconfirm2:
    'Assurez-vous que les compresseurs restent en marche pendant au moins 2 heures afin que le système puisse détecter les fuites potentielles.',
  startEnd: 'Début - Fin',
  leakPeriod: 'Période de fuite',
  productionLeakRate: 'Taux de fuite du produit',
  addNextPeriodicShutdown: 'Ajouter le projet de période de fuite suivant',
  confirmDeleting: "Supprimer la période d'arrêt pour les périodes {{period}}",
  delete: 'Supprimer',
  excludeFuturePeriodicShutdowns: "Exclure les périodes d'arrêt futures",
  leakFlow: 'Fuite mesurée',
  estimatedLeakTooltip: 'Fuite estimée ({{estimatedLeak}}',
  sampledFlowDuringShutdownTooltip: "Débit échantillonné pendant l'arrêt ({{sampledFlowDuringShutdown}}",
  productionLeakRateTooltip:
    'Ce calcul est effectué en normalisant le débit de fuite à la pression cible, puis en le divisant par le débit de production moyen ({{productionLeakRate}}',
  overlappingDates: 'Les dates qui se chevauchent ne sont pas valides',
  updateLeakAudit: "Mettre à jour l'audit de fuite",
  updateAudit: "Mettre à jour l'audit",
  leakAuditUpdatedSuccessfully: 'Audit de fuite mis à jour avec succès',
  theAuditDatesHaveBeenUpdated: "Les dates de l'audit ont été mises à jour",
  leakAuditUpdatedAndPublishedSuccessfully: 'Le brouillon de fuite a été publié au client',
  errorUpdatingLeakAudit: "Erreur lors de la mise à jour de l'audit de fuite",
  leakAuditRejectedSuccessfully: 'Audit de fuite rejeté avec succès',
  errorRejectingLeakAudit: "Erreur lors du rejet de l'audit de fuite",
  leakAuditBookedSuccessfully: 'Audit de fuite réservé avec succès',
  scheduleLeakAudit: "Planifier l'audit de fuite",
  setAudit: "Définir l'audit",
  reviewLeakAudit: "Examiner l'audit de fuite",
  rejectAudit: "Rejeter l'audit",
  updateAndPublish: 'Mettre à jour et publier',
  viewLeak: 'Voir la fuite',
  // MeasurementSegmentation tab
  totalWasteFlow: 'Flux total des déchets',
  totalProductionFlow: 'Flux de production total',
  productionLine: 'Ligne {{productionLineName}}',
  totalPlant: ' Toute l’usine',
  production: 'Production',
  waste: 'Déchets',
  flowLabel: 'Débit',
  effective: 'Efficace',

  // Insights
  insights: 'Apercus',
  events: 'Évènements',
  // Overview tab
  ytdValue: 'VALEUR YTD',
  lifetimeValue: 'VALEUR GLOBALE',
  savingsOpportunity: "OPPORTUNITÉ D'ÉCONOMIES",
  saved: 'SAUVEGARDÉ',
  actionsPending: 'Actions en attente',
  actionsTaken: 'Mesures prises',
  rejected: 'rejetés',
  Risk: 'Risque',
  measurementLogTitle: 'Les données ci-dessous se réfèrent à la période au cours de laquelle la fuite a été détectée.',
  // Events tab
  pendingTasksOnly: 'Tâches en attente uniquement',
  dateOpened: "Date d'ouverture",
  insightName: 'Nom Insight',
  asset: 'Atout',
  valueType: 'Type de valeur',
  value: 'Valeur {{currency}}',
  dateCompleted: "Date d'achèvement",
  InProgress: 'En cours',
  Reject: 'Refuser',
  estimatedDeliveredValue: 'Valeur livrée estimée',

  // Engine
  wizard: 'Assistant',
  draft: 'Brouillon',
  newDraft: 'Nouveau brouillon',
  createNewDraft: 'Créer un nouveau brouillon',
  published: 'Publié',
  recommended: 'Recommandé',
  publishDraftConfirmation:
    'Êtes-vous sûr de vouloir publier toutes les modifications effectuées sur tous les onglets de configuration?',
  publishRecommendationConfirmation:
    'Cette version sera directement publiée en production{{draftVersionText}}. Souhaitez-vous continuer ?',
  draftVersionText: ' et remplacer le brouillon existant {{draftVersion}}',
  newRecommendedConfiguration:
    'Une nouvelle version du contrôleur dynamique est disponible. Date de création: {{createdDate}}',
  'publishConfirmationEngine1.0':
    'Cette station est gérée par Dynamic Controller version 1.0. Pour mettre à jour la version 1.5, rendez-vous sur ReTool et remplacez la version du moteur par 1.5. Une fois cela fait, cette version publiée gérera la station.',
  revertToPublishedConfirmation:
    'Êtes-vous sûr de vouloir remplacer les configurations par celles actuellement publiées?',
  missingMandatoryFieldValue:
    'Le champ modifiable = "{{field}}" du compresseur = "{{compressor}}" de la table = "{{table}}" nécessite une entrée valide.',
  recommendationFlowLevelsChanged:
    'Les niveaux de débit ou les plages de pression ont été modifiés, par conséquent les règles de repli existantes ne sont plus valides et ont été supprimées.',
  revertToPublished: 'Revenir à Publié',
  publish: 'Publier',
  settings: 'Réglages',
  next: 'Suivant',
  back: 'Retour',
  finish: 'Terminer',
  cancel: 'Annuler',
  defaults: 'Valeurs par défaut',
  noDynamicController: "Le contrôleur dynamique n'a pas été défini.",
  // Recommendation
  createdOn: 'Créé le: ',
  approvalReport: "Rapport d'approbation",
  // Rules Generator
  mainRanges: 'Gammes principales',
  mainRangesConfiguration: 'Configuration du débit et de la pression',
  rulesGenerator: 'Générateur de règles',
  flowLevels: 'NIVEAUX DE DÉBIT',
  'Flow Levels': 'Niveaux de débit',
  pressureLevels: 'PLAGES DE PRESSION',
  result: 'RÉSULTAT',
  rules: 'Règles',
  // Flow Levels
  units: 'Unités',
  name: 'Nom',
  lowerBoundFlow: 'Débit limite inférieur',
  upperBoundFlow: 'Débit limite supérieur',
  addRangeName: 'Ajouter un nom de gamme',
  addUpperRange: 'Ajouter une gamme supérieure',
  addLevel: 'Ajouter un niveau',
  addPressureRange: 'Ajouter une plage de pression',
  infinity: 'Infinity',
  flowLevelsChanged:
    'Les plages de valeurs des capteurs sont modifiées, modifiez les valeurs des règles du tableau en conséquence et enregistrez les dernières valeurs',
  changesInMainRangesAffectFallbackRules:
    'Les modifications des fourchettes principales ont entraîné des modifications des règles de repli. Êtes-vous sûr de vouloir continuer?',
  // Pressure Levels
  range: 'Gamme',
  id: 'ID',
  lowerBoundPressure: 'Pression limite inférieure',
  upperBoundPressure: 'Pression limite supérieure',
  thisPressureLevel: 'ce niveau de pression',
  // Result
  mainRangesResult: 'RÉSULTAT',
  flowLevel: 'Niveau de débit',
  rule: 'Règle',
  // Sensors
  sensors: 'Capteurs',
  sensorsSelection: 'Configuration des KPI',
  sensorsConfiguration: 'Configuration des capteurs',
  flowSensorsPriority: 'SÉLECTION DES CAPTEURS DE DÉBIT',
  pressureSensorsPriority: 'SÉLECTION DES CAPTEURS DE PRESSION',
  sensorsPriorityResult: 'RÉSULTAT',
  main: 'Principale',
  fallback: 'Solution de repli {{priority}}',
  fallbacks: 'Solutions de repli',
  logic: 'Logique',
  online: 'En ligne',
  any: "N'importe lequel",
  all: 'Tous',
  average: 'Moyenne',
  minimum: 'Minimum',
  maximum: 'Maximum',
  sum: 'Somme',
  addFallback: 'Ajouter Fallback',
  defaultBehaviour: 'Comportement par défaut',
  chooseRule: 'Choisissez une règle',
  customRule: 'Règle personnalisée',
  turnOffEngine: 'Éteindre le moteur',
  ruleGenerator: 'Générateur de règles',
  newRuleName: 'NOUVEAU NOM DE RÈGLE',
  // Result
  flowSensorsSelection: 'Sélection des capteurs de débit',
  pressureSensorsSelection: 'Sélection des capteurs de pression',
  // Compressors
  compressors: 'Compresseurs',
  compressorGroups: 'Groupes de compresseurs',
  rotation: 'Rotation',
  on: 'Allumer',
  off: 'Éteindre',
  repeatEvery: 'Répétez chaque',
  repeatOn: "Répétez l'opération",
  time: 'Heure',
  weeks: 'semaines',
  addCompressorGroup: 'Ajouter un nouveau groupe de compresseurs',
  deletePopconfirmTitle: 'Vous êtes sur le point de supprimer {{item}}. Êtes-vous sûr ?',
  // Default Rule
  defaultRule: 'Règle par défaut',
  defaultSetpoints: 'Valeurs par défaut du tableau',
  defaultSetpointsConfiguration: 'Valeurs par défaut du tableau',
  groupAndPriority: 'Groupe | Priorité',
  order: 'Ordre',
  load: 'Chargement',
  unload: 'Déchargement',
  autoStop: 'Arrêt automatique',
  immediateStop: 'Arrêt immédiat',
  pressureDrop: 'Chute de pression',
  vsdTarget: 'Cible',
  modulate: 'Moduler',
  bandConfiguration: 'Configuration de la bande',
  defaultSetpointsInfoMessage:
    'Les points de consigne sont basés sur les relevés de pression de la conduite du compresseur (compte des chutes de pression)',
  setpointsLoadUnloadValidation:
    'La valeur de consigne de déchargement doit être supérieure à la valeur de consigne de charge.',
  pidChanges: `Une nouvelle stratégie moteur doit être définie et publiée puisque le P&ID de la station a changé. Vous trouverez ci-dessous la liste des actifs qui affectent la stratégie de contrôle:`,
  compressorsAdded: 'Compresseurs ajoutés:',
  compressorsRemoved: 'Compresseurs retirés:',
  flowKPIModified: 'KPI de flux modifié:',
  pressureKPIModified: 'KPI de pression modifié:',
  compressorPriorityChangedToIgnore: 'La priorité du compresseur est passée de (Actif/Secours) à Ignorer :',
  compressorPriorityChangedFromIgnore: 'La priorité du compresseur est passée de Ignorer à (Actif/Secours) :',

  //package care
  careAgrremntID: 'ID du contrat',
  annugalHoursCoverage: 'Couverture annuelle des heures ',
  startDate: 'Date de début',
  expirationDate: "Date d'expiration",
  packageCare: 'PackageCARE',
  packageCareStatus: 'État de PackageCARE',
  inactive: 'Inactif',
  invalidDate: 'Date non valide',
  package: 'Colis',
  planned: 'Planifié',
  parts: 'Pièces',
  care: 'CARE',
  careServiceSignUp: 'Inscrivez-vous au plan de service CARE',
  noCareProgram: 'Programme No Care',
  thankInterestCare: "Merci de l'intérêt que vous portez à CARE!",
  noCarePlan: ' Pas de plan CARE',
  activeAsset: 'est activé pour cet actif',
  tm: 'TM',
  // Fallback Scenarios
  fallbackScenarios: 'SCÉNARIOS DE REPLI',
  addScenario: 'Ajouter un scénario',
  onFailureOf: "En cas d'échec de",
  singleRuleForAllFlowLevels: 'Règle unique pour tous les niveaux de débit',
  logicPerFlowLevel: 'Logique par niveau de débit',
  // Validations
  flowRanges: 'Plages de débit',
  pressureRanges: 'Plages de pression',
  rangesAreMandatory: '$t({{ranges}}) sont obligatoires',
  compressorsAreMandatory: 'Les compresseurs sont obligatoires',
  higherUpperBound: 'Doit être supérieur à la limite supérieure précédente',
  mustBeEqualOrHigherThan1: 'Doit être égal ou supérieur à 1',
  compressorsCombinationMustBeUnique: 'La combinaison des compresseurs doit être unique',
  compressorIsNotCompatibleToGroup: 'Tous les compresseurs ajoutés aux groupes doivent avoir les mêmes actions',
  compressorsMustHaveSameHp: 'Les compresseurs doivent avoir la même puissance HP',
  oneFallbackOptionShouldBeSelected: 'Une option de repli doit être sélectionnée',
  oneRuleShouldBeSelected: 'Une règle doit être sélectionnée',
  sensorsAreMandatory: 'Les capteurs sont obligatoires',
  sensorFlowCombinationMustBeUnique: 'La combinaison de la configuration du débit du capteur doit être unique',
  // Rules
  rulesOverview: 'Règles',
  rulesEditor: 'Éditeur de règles',
  // Rules Overview
  no: 'Non',
  ord: 'ORD',
  lo: 'LO',
  un: 'UN',
  target: 'TRG',
  mod: 'MOD',
  aut: 'AUT',
  imm: 'IMM',
  pd: 'PD',
  bnd: 'BND',
  // new fallback columns
  compressorNumber: 'Numéro de compresseur',
  titleOrder: 'ORD',
  titleLoad: 'LO',
  titleUnload: 'UN',
  titleTarget: 'TRG',
  titleModulate: 'MOD',
  titleAutoStop: 'AUT',
  titleImmediateStop: 'IMM',
  titlePressureDrop: 'PD',
  titleBandConfiguration: 'BND',
  // Rules Editor
  standalone: 'Autonome',
  viewMode: "Mode d'affichage",
  editMode: 'Mode édition',
  save: 'Enregistrer',
  discard: 'Oui (jeter)',
  keepEditing: 'Non (continuez à modifier)',
  // Fallback Overview
  fallbackOverview: 'Solution de repli',
  sensorsLogic: 'Logique des capteurs',
  compressorsGroupOrder: 'Ordre des groupes de compresseurs',
  compressorsFallback: 'Compresseurs Fallback',
  flowSensorsFallback: 'Capteurs de débit Fallback',
  pressureSensorsFallback: 'Capteurs de pression Fallback',
  sensorPriorityInfoMessage: 'En cas de panne, la logique suivante sera exécutée',
  editScenarios: 'Modifier les scénarios',
  // Version History
  versionHistory: 'Historique des versions',
  lastUpdated: 'Dernière mise à jour',
  version: 'Version',
  changes: 'Changements',
  revertPublishedVersion:
    'En revenant à la version précédente, une nouvelle stratégie sera publiée et remplacera le projet existant. Souhaitez-vous continuer ?',
  actions: 'Actions',
  recommendation: 'Recommandé',
  algo: 'Algo',
  manual: 'Manuel',

  // station risk
  Low: 'Faible',
  Moderate: 'Modéré',
  High: 'Haut',
  SYSTEM_AVAILABILITY: 'disponibilité du système',
  REALTIME_SYSTEM_CAPACITY: 'capacité du système en temps réel',
  'System Health': 'État de santé du système',
  'System Degradation': 'Dégradation du système',
  'System Single Point of Failure Risk': 'Risque de point de défaillance unique du système',
  'Available flow subtitle': 'Disponible',
  'Peak production subtitle': 'Production maximale',
  'Month Over Month avg Flow Trend': "Tendance du flux moyen d'un mois à l'autre",
  'peak production delta increase part1': "Votre production d'air comprimé d'un mois sur l'autre a augmenté de ",
  'peak production delta increase part2':
    ' reflétant soit une croissance de la production, soit une éventuelle fuite croissante de la croissance',
  'available delta decrease part1': 'Votre capacité de production mensuelle reflète une baisse des performances de ',
  'available delta decrease part2':
    '. Vérifiez que vos compresseurs ne sont pas entretenus et ne présentent aucun mauvais fonctionnement.',
  'realtime flow over peak error':
    "Erreur - La valeur en temps réel {{realtime}} est supérieure au débit de pointe {{peakSupplyFlow}}. Veuillez contacter le service client d'Ecoplant",
  'realtime flow over total flow error':
    'La valeur en temps réel {{realtime}} est supérieure au débit total de la station {{totalFlow}}.',
  'realtime flow over max available flow error':
    'La valeur en temps réel {{realtime}} est supérieure au débit maximum disponible {{totalFlow}}.',
  'Station risk degradation tooltip text':
    'Dégradation opérationnelle du système et de chaque compresseur par rapport à sa spécification nominale',
  'Realtime Production': 'Production en temps réel',
  'Peak Production': 'Production maximale',
  PEAK_PRODUCTION: 'production maximale',
  'Avg Production': 'Production moyenne',
  AVG_PRODUCTION: 'production moyenne',
  'Max Available': 'Maximum disponible',
  Degradation: 'Dégradation',
  MODERATE_RISK: 'risque modéré',
  LOW_RISK: 'faible risque',
  STATION_DEGRADATION: 'dégradation de la station',
  PLANNED_AVAILABILITY: 'disponibilité planifiée',
  CURRENT_YEAR: 'ANNÉE EN COURS',
  PREVIOUS_YEAR: 'ANNÉE PRÉCÉDENTE',

  // users management
  'Users Management': 'Gestion des utilisateurs',
  'Manage Users': 'Gérer les utilisateurs',
  'Create new user': 'Créer un nouvel utilisateur',
  'User must be assigned to at least one station': "L'utilisateur doit être assigné à au moins une station",
  'User created successfully': 'Utilisateur créé avec succès',
  'User creation failed, please contact support for further information':
    "La création de l'utilisateur a échoué, veuillez contacter le service client pour plus d'informations",
  'You are about to delete this user completely. Are you sure?':
    'Vous êtes sur le point de supprimer définitivement cet utilisateur. Êtes-vous sûr ?',
  'Delete user': 'Supprimer un utilisateur',
  'Changes will not be saved. Are you sure?': 'Les modifications ne seront pas enregistrées. Êtes-vous sûr ?',
  'Discard changes': 'Ignorer les modifications',
  'First name': 'Prénom',
  'Please input your first name': 'Veuillez saisir votre prénom',
  'Last name': 'Nom de famille',
  'Please input your last name': 'Veuillez saisir votre nom de famille',
  Email: 'Courrier électronique',
  'Please input your email': 'Veuillez saisir votre adresse e-mail',
  'Please input a valid email address': 'Veuillez saisir une adresse e-mail valide',
  'Measurement system': 'Système de mesure',
  'Please choose your measurement system': 'Veuillez choisir votre système de mesure',
  'Dial code': 'Code de numérotation',
  'Please input your dial code': 'Veuillez saisir votre code de numérotation',
  Number: 'Numéro',
  'Please input your number': 'Veuillez saisir votre numéro',
  '9 or 10 digits are allowed': '9 ou 10 chiffres sont autorisés',
  'Only numbers are allowed!': 'Seuls les chiffres sont autorisés!',
  'Please choose a station': 'Veuillez sélectionner une station',
  'Please choose a role': 'Veuillez choisir un rôle',
  'You are about to remove this user’s access to this station. Are you sure?':
    "Vous êtes sur le point de supprimer l'accès de cet utilisateur à cette station. Êtes-vous sûr ?",
  'E.g. John': 'Par exemple John',
  'E.g. Doe': 'Par exemple Biche',
  'John@domain.com': 'John@domain.com',
  'Select measurement system': 'Sélectionnez le système de mesure',
  '+001': '+001',
  '000000000': '000000000',
  'Select station': 'Sélectionnez une station',
  'Select role': 'Sélectionnez un rôle',

  // EULA
  'License Agreement': 'Contrat de licence',
  Decline: 'Déclin',
  Accept: 'Accepter',

  // Water Temperature
  WATER_TEMPERATURE: "Température d'eau",
  IN: 'Entrée',
  OUT: 'Sortie',

  // Metrics
  PRESSURE: 'Pression',
  FLOW: 'Débit',
  WATER_FLOW: "Débit d'eau",
  WATER_PRESSURE_IN: "Pression d'eau d'entrée",
  WATER_PRESSURE_OUT: "Pression d'eau de sortie",
  WATER_PRESSURE_DELTA: "Perte de charge pression d'eau",
  EST_FLOW: 'Débit est.',
  POWER: 'Puissance',
  EST_POWER: 'Puissance est.',
  TEMPERATURE: 'Température',
  AIR_TEMPERATURE: "Température de l'air",
  AIR_TEMPERATURE_SENSOR: "Capteur de température de l'air",
  DEW_POINT_TEMPERATURE: 'Point de rosée',
  INLET_WATER_TEMPERATURE: "Température d'entrée d'eau",
  OUTLET_WATER_TEMPERATURE: "Température de sortie d'eau ",
  CURRENT: 'En cours',
  OIL_TEMPERATURE: "Température d'huile",
  INVERTER_SPEED: 'Vitesse du variateur',
  RUN_HOURS: 'Heures de fonctionnement',
  LOAD_HOURS: 'Heures en charge',
  HUMIDITY: 'Humidité',
  CONTROL_MODE: 'Mode de contrôle',
  MINIMUM_PRESSURE: 'Pression minimale',
  MAXIMUM_PRESSURE: 'Pression maximale',
  NEXT_SERVICE_HOURS: 'Heures avant maintenance',
  NEXT_SERVICE_NAME: 'Nom maintenance suivante',
  ACTIVITY: 'Activité',
  SPECIFIC_POWER: 'Puissance spécifique',
  EST_SPECIFIC_POWER: 'est. Puissance spécifique',
  EST_INVERTER_SPEED: 'est. Vitesse variateur',
  POWERED_ON: 'Mise sous tension',
  INLET_VALVE_OPENING: 'Ouverture de la vanne IV',
  BYPASS_VALVE_OPENING: 'Ouverture de la vanne BV',
  CENTRIFUGAL_TARGET_SETPOINT: 'Point de consigne centrifuge',
  OPERATION_MODE: 'Mode de fonctionnement',
  DRYER_FILTER_SERVICE_HOURS: 'Heures de service du filtre du sécheur',
  DRYER_DESICCANT_SERVICE_HOURS: 'Heures de service du dessiccant du sécheur',
  DRYER_VALVE_SERVICE_HOURS: 'Heures de service de la vanne du sécheur',
  DRYER_LEFT_TOWER_ACTIVITY: 'Activité de la tour gauche du sécheur',
  DRYER_RIGHT_TOWER_ACTIVITY: 'Activité de la tour droite du sécheur',
  DRYER_BLOWER_ACTIVITY: 'Activité d’un sécheur constitué d’un ventilateur',
  DRYER_HEATER_ACTIVITY: 'Activité du réchauffeur du sécheur',
  DRYER_TEMPERATURE_SETPOINT_CELSIUS: 'Point de réglage de température du sécheur en degrés Celsius',
  DRYER_OPERATION_MODE: 'Mode de fonctionnement du sécheur',
  DRYER_EXTENDED_ACTIVITY: 'Activité prolongée du sécheur',
  EXTERIOR_AMBIENT_TEMPERATURE: 'Température ambiante extérieure',
  FREQUENCY: 'Fréquence',
  P_H: 'PH',
  AMMONIA_AMMONIUM: 'Ammoniac (NH3) /Ammonium (NH4+)',
  NITRATE_NO_3: 'Nitrate (NO3-)',
  NITRITE_NO_2: 'Nitrite (NO2-)',
  OXIDATION_REDUCTION_POTENTIAL: 'Potentiel de réduction de',
  DISSOLVED_OXYGEN: 'Taux oxygène',
  BLOWER_SPEED: 'Vitesse du ventilateur',
  BLOWER_TARGET_SPEED: 'Vitesse Cible du Souffleur',
  INFLUENT_FLOW: 'Débit influent',

  COMMAND_WAITING_FOR_DELIVER: 'En attente de livraison',
  COMMAND_RECEIVED_AND_UPDATED: 'Reçu et mis à jour',
  COMMAND_FAILED_TO_UPDATE: 'Impossible de mettre à jour',
  COMMAND_FAILED_TIME_OUT: "Échec du délai d'attente",
  COMMAND_FAILED_OFFLINE: 'Échec hors ligne',
  COMMAND_IGNORED_UNCHANGED_VALUE: 'Valeur inchangée ignorée',

  'Ambient Temperature': 'Température ambiante',
  'Ambient Humidity': 'Humidité ambiante',

  'Failed retrieving commands history': "Impossible de récupérer l'historique des commandes",
  alpha: 'Alpha',
  beta: 'Bêta',
  powerUsersOnly: 'Utilisateurs expérimentés uniquement',
  allowCookies: 'Autoriser les cookies',
  decline: 'Refusé',

  general: 'Général',
  true: 'Vrai',
  false: 'Faux',
  'Clear all engine configurations': 'Effacer toutes les configurations du moteur',
  'Engine ready': 'Moteur prêt',
  yes: 'Oui',
  'Are you sure you want to delete all data?': 'Êtes-vous sûr de vouloir supprimer toutes les données?',

  energySavingsReportTitle: 'Rapport Ecoplant 360',
  energySavingsReportDescription:
    "Vous trouverez ci-dessous les économies d'énergie réalisées grâce au contrôleur dynamique Ecoplant. " +
    'Il est présenté dans différentes résolutions temporelles, jour précédent, mois à jour, année à date et ' +
    'Des économies à vie. Il est présenté en (1) pour cent (%) (et en kWh) (2) en monnaie locale (3) tonnes métriques estimées ' +
    "de réduction des GES. Les économies sont calculées sur la base d'une comparaison avec la période de référence et sa saisie " +
    'de puissance spécifique (S/P).',

  insightsReportDescriptionOne:
    'Ecoplant 360 fournit à ses utilisateurs des informations continues grâce à notre système ou à nos experts qui examinent ' +
    'le système. Ces informations sont divisées en trois catégories: énergie, maintenance et risques. Toutes les informations auraient ' +
    "une indication d'action, soit une action en attente, soit une action entreprise. Affichage du montant estimé en dollars américains correspondant.",
  insightsReportDescriptionTwo:
    "Pour toute action en attente, veuillez cliquer sur l'aperçu correspondant pour les actions supplémentaires requises. Pour toute précision " +
    'et pour plus de détails techniques, veuillez contacter votre customer success manager.',
  insightsReportDescriptionThree: "L'abonnement à Live Insights peut être complété sur le tableau de bord Ecoplant 360",

  leakageReportDescription:
    'Ecoplant 360 fournit à ses utilisateurs un aperçu des fuites estimées. ' +
    'Pour garantir une lecture des fuites à jour, veuillez ajouter au tableau de bord des valeurs votre prochain arrêt de production prévu. ' +
    "Pendant la période d'arrêt et afin de mesurer les fuites, le compresseur serait maintenu en marche pendant quelques " +
    'heures pour que le système puisse mesurer la consommation due aux fuites du système.',

  openInsightsReportDescriptionOne:
    'Vous trouverez ci-dessous une liste de toutes les informations ouvertes indiquant à la fois les actions en attente et les actions en cours.',
  openInsightsReportDescriptionTwo:
    "Pour plus de précisions et d'analyses, veuillez contacter votre représentant du service clientèle.",
  openInsightsReportFooterText:
    "Sur le tableau de bord de la valeur d'Ecoplant 360, vous pourrez explorer des informations supplémentaires.",

  //LIGHT Project
  enableSystemControl: 'Activer le système de contrôle',
  isCalculated: '{{metric}} est calculé.',
  FlowUpper: 'Flux',
  PowerUpper: 'Puissance',
  toRecord: ' Pour enregistrer votre système {{field}} avec précision, ',
  performance: 'performance',
  AddNewCompressor: 'Ajouter un nouveau compresseur',
  performanceKpisCalculated: 'Les KPI de performance sont calculés.',
  learnMoreIncreaseSavingsNum:
    'En savoir plus & Réalisez des économies grâce à #{{num}} informations supplémentaires sur le système',
  learnMoreIncreaseSavings:
    'En savoir plus & faites des économies grâce à des informations supplémentaires sur le système',
  learnMoreRecord: 'En savoir plus& enregistrez vos performances avec précision',
  clickHere: 'Cliquez ici',
  expandYourStation: 'Développez votre station et obtenez un aperçu complet de tous les composants pertinents',
  addCompressor: 'Pour ajouter un compresseur, ',
  Integration: 'Intégration',
  externalDeviceId: 'ID externe',
  startIntegrationProcess: " et lancez le processus d'intégration",
  getSensorPackage: ' et procurez-vous le bon ensemble de capteurs.',
  toRecordPerformance: '  Pour enregistrer vos performances avec précision, ',
  alwaysPerform:
    ' et fonctionnent toujours dans le mode de fonctionnement optimal grâce à la commande automatique du système',
  calculatedValues: 'Valeurs calculées',
  learnMoreAndEnableSystemControl: 'En savoir plus & Activer le contrôle du système',
  learnMoreAndEnableKPIs: 'En savoir plus & Activez KNOW - SYSTEM pour obtenir vos KPI de performance individuels',
  learnMoreAndEnableLeakage: 'En savoir plus & Activer les fuites',
  energySavingsSystemTierTooltipPart1:
    "Opportunités d'économie d'énergie attendues sur la base d'études de cas réelles. Pour toujours fonctionner dans un mode de fonctionnement optimal et réaliser ces économies, ",
  energySavingsSystemTierTooltipPart2: ' et ajoutez System Control.',
  requestTierConfirmationMessageLine1: 'Un message est envoyé à Ecoplant.',
  requestTierConfirmationMessageLine2: 'Nous vous contacterons dans les plus brefs délais',
  backgroundDataYearlyView:
    'Les données de base sont des exemples du bilan énergétique annuel, y compris les économies réalisées.',
  backgroundDataLeakage: "Les données d'arrière-plan sont des exemples du widget Leakage.",
  additionalSensors: 'Capteurs supplémentaires',
  addPressureSensorPack:
    ' et ajoutez un pack de capteurs de pression pour accéder aux conditions de pression et aux fuites du système',
  addStationKpis: ' et obtenez les KPI complets de votre station, cliquez ici et activez la vue système',
  addIndividualSensors: " et ajoutez des capteurs individuels pour accéder à l'état de fonctionnement de votre système",
  system: 'Système',
  flowIsCalculated: 'Le débit est calculé',
  learnMoreAndEnableSystemHealth: 'En savoir plus & Activer la santé du système',
  lockedFunctionality: 'Fonctionnalité verrouillée',
  backgroundDataSystemHealth: "Les données d'arrière-plan sont des exemples du widget System Health.",
  systemView: 'SAVOIR - SYSTÈME',
  systemViewDescription:
    "Bénéficiez d'une supervision complète des performances de votre système grâce à une carte d'&identification IP individuelle, aux tendances du système, à la surveillance des risques du système et à des informations supplémentaires sur le système pour améliorer les performances et la santé globales de votre système.",
  learnMoreAndWatchVideo: 'En savoir plus & Regarder la vidéo',
  assetCount: 'Compresseurs {{assetCount}}',
  mon: 'mensuel',
  perAsset: 'par compresseur',
  billedAnnually: 'Facturé annuellement ou ',
  monthly: ' mensuel',
  expectedAnnualSavings: 'Économies annuelles attendues',
  expectedROI: 'Retour sur investissement attendu',
  years: '< {{years}} Années',
  startOneMonthTrial: "Commencez un mois d'essai",
  orPurchaseNow: 'ou achetez dès maintenant',
  allAssetViewFeatures: "TOUT SAVOIR - Caractéristiques de l'ATOUT, en plus:",
  individual: 'Individuel',
  pidMap: "Carte & d'identification IP",
  monitorAndSupervise:
    "pour surveiller et superviser les performances de l'ensemble de votre système et identifier instantanément les composants critiques.",
  systemHealthStatus: 'État de santé du système',
  isPartOf:
    'fait partie du Value Dashboard, qui surveille le niveau de risque de votre système et de votre production en temps réel.',
  systemInsights: 'Informations sur le système',
  improveSystemPerformance:
    "sur l'énergie, la maintenance et les & risques améliorent les performances et la santé du système et réduisent les coûts d'exploitation.",
  derivedSystemEfficiencyParameters: "Paramètres d'efficacité du système dérivés",
  suchAs: 'tels que la pression, le débit, la puissance et la puissance spécifique du système;',
  systemTrends: 'Tendances du système',
  toAnalyzeAndOptimize:
    ' pour analyser et & optimiser les performances de votre système sur la base de données historiques.',
  backgroundDataMap: "L'&ID P d'arrière-plan représente un exemple de la carte du système",
  backgroundData: 'Les données de base sont des exemples',
  simpleControlDescription:
    "Grâce au moteur de commande simple, vous améliorez l'efficacité globale et l'utilisation de votre système et réduisez la durée de fonctionnement des compresseurs de secours et de location. Cela vous permet de réduire considérablement les coûts énergétiques de votre système.",
  dynamicControlDescription:
    "Débloquez le moteur de contrôle dynamique complet pour analyser et ajuster automatiquement le fonctionnement aux besoins de production pour une efficacité maximale du système. En outre, vous pouvez détecter et isoler les fuites d'air afin d'améliorer encore l'efficacité et de réduire au minimum vos coûts énergétiques totaux.",
  simpleControl: 'CONTRÔLE',
  allSystemViewFeatures: 'TOUT SAVOIR - Caractéristiques du système, en plus:',
  simpleControlEngine: 'Moteur de contrôle simple',
  toContinouslyOptimize: "pour optimiser en permanence l'efficacité du système et l'utilisation du compresseur",
  energySavingsWidget: "Widget d'économies d'énergie",
  toProvideComprehensiveOverview:
    "pour fournir un aperçu complet des économies d'énergie totales (par jour, mois, année &amp; et total) sur la base de l'efficacité optimisée du système par rapport à votre fonctionnement initial",
  greenhouseGasEmission: 'Émission de gaz à effet de serre',
  savingsBasedOn: "économies basées sur l'efficacité optimisée du système",
  allSimpleControlFeatures: 'Toutes les fonctionnalités CONTROL, plus:',
  dynamicControlEngine: 'Moteur de contrôle dynamique',
  predictiveAlgorithms:
    "Des algorithmes prédictifs évaluent votre consommation d'énergie quotidienne, hebdomadaire et saisonnière en contrôlant dynamiquement les systèmes via des profils de production afin de minimiser le gaspillage d'énergie, la redondance et les surcoûts des services publics.",
  leakageWidget: 'Widget de fuite',
  forDetectingAndIsolating:
    "permet de détecter et d'isoler les emplacements des fuites de manière significative, ce qui réduit considérablement vos pertes d'énergie.",
  continuousAutiding: 'Audit continu ',
  reviewYourSystemPerformance: 'Passez en revue les performances et le niveau de santé de votre système',
  getYourPrice: 'Obtenez votre prix',
  systemControl: 'Contrôle du système',
  learnMoreAndRequestTrial: 'EN SAVOIR PLUS & DEMANDER UN ESSAI',
  ecoplantOffering: 'Offre Ecoplant',
  addOns: 'Modules complémentaires',
  yourCurrentVersion: 'Votre version actuelle',
  noStationsAvailable: 'Aucune station disponible',
  language: 'Langue',
  selectLanguage: 'Sélectionnez la langue',
  languageUpdateSuccess: 'Langage mis à jour avec succès',
  languageUpdateFailed: 'La modification du langage a échoué',
  english: 'Anglais',
  french: 'Français',
  german: 'Allemand',
  Station: 'Station',
  Role: 'Rôle',
  SMS: 'SMS',
  Insight: 'Aperçu',
  Weekly: 'Hebdo',
  Monthly: 'Mensuel',
  Avg: 'Moyen',
  kWh: 'kWh',
  leakMeasurement: 'Mesure des fuites',
  valueDashboard: 'Tableau de bord des valeurs',
  userName: "Nom d'utilisateur",
  phoneNumber: 'Numéro de téléphone',
  'MT GHG': 'MT DE GES',
  forMoreThan: 'depuis plus de',
  userAssociatedStations: 'Stations associées',
  saveChanges: 'Enregistrer les modifications',
  'Min / Max': 'Minimum/Max',
  simulationValue: '(Valeur de simulation)',
  actualValue: '(Valeur réelle)',
  Operation: 'Opération',
  Unselect: 'Désélectionner',
  'Manufacturer and Custom Alerts with Shutdown Severity':
    'Alertes du fabricant et personnalisées avec gravité des arrêts',
  'Manufacturer and Custom Alerts with Warning Severity':
    'Alertes du fabricant et personnalisées avec gravité des avertissements',
  'Manufacturer and Custom Alerts with Service Severity':
    'Alertes du fabricant et personnalisées indiquant la gravité du service',
  'Notifies on Periodic Shutdown event creation, 1 day before the event':
    "Notifie la création d'un événement d'arrêt périodique, 1 jour avant l'événement",
  'Notifies when a new Insight Event is created': "Notifie lorsqu'un nouvel événement Insight est créé",
  'Notifies when the Dynamic Controller is turned On or Off':
    'Avertit lorsque le contrôleur dynamique est activé ou désactivé',
  "Notifies when a Device's Maintenance flag is changed":
    "Avertit lorsque l'indicateur de maintenance d'un appareil est modifié",
  'Notifies when a Report is generated': "Notifie lorsqu'un rapport est généré",
  'Notifies when a Station is switched On or Off': "Avertit lorsqu'une station est allumée ou désactivée",
  "couldn't fetch data": 'Impossible de récupérer les données',
  'User update failed': 'La mise à jour utilisateur a échoué',
  'User deletion failed': "La suppression de l'utilisateur a échoué",
  'User updated successfully': 'Utilisateur mis à jour avec succès',
  'User deleted successfully': "L'utilisateur a été supprimé avec succès",
  Refresh: 'Actualiser',
  'Activity Log': "Journal d'activité",
  Compressors: 'Compresseurs',
  'Learn More And Enable Leakage': 'En savoir plus et prévenir les fuites',
  'Background Data Leakage': "Fuite de données d'arrière-plan",
  'Sign in': 'Connectez-vous',
  OR: 'OU',
  'Login with SSO': 'Connectez-vous avec SSO',
  'is Activated': 'est activé',
  'is Deactivated': 'est désactivé',
  'is Disabled - Under Maintenance': 'est désactivé - En cours de maintenance',
  'is Disabled by Local Control Switch': 'est désactivé par le commutateur de commande local',
  'is Disabled by Cloud Control Switch': 'est désactivé par Cloud Control Switch',
  'IN MAINTENANCE': 'EN MAINTENANCE',
  EnergySavings: "Économies d'énergie",
  'LIFE TIME SAVINGS': 'ÉCONOMIES DE TEMPS',
  'Unarchive Alert': 'Alerte de désarchivage',
  'archive alert failed': "L'alerte d'archivage a échoué",
  'Select All': 'Tout sélectionner',
  'Archive Selected Alerts': 'Archiver les alertes sélectionnées',
  'Restore default': 'Restaurer la valeur par',
  'Devices Names': 'Noms des appareils',
  Close: 'Fermer',
  Activity: 'Activité',
  'Value may depend on multiple sensors.': 'La valeur peut dépendre de plusieurs capteurs.',
  Minutes: 'Minutes',
  'kW based Calculation': 'Calcul basé sur le kW',
  'Target Setpoint': 'Point de consigne cible',
  'PRESSURE SET POINTS': 'POINTS DE CONSIGNE DE PRESSION',
  'Water Temperature': "Température de l'eau",
  'Set point': 'Point de consigne',
  'DEW POINT': 'POINT DE ROSÉE',
  'NEXT SERVICE': 'SERVICE SUIVANT',
  ACTIVTY: 'ACTIVITÉ',
  'In maintenance': 'En maintenance',
  'Device Details': "Détails de l'appareil",
  'This feature is currently disabled.': 'Cette fonctionnalité est actuellement désactivée.',
  Revert: 'Revenir',
  'Open Insights': 'Open Insights',
  'Sign in without Single Sign On': 'Connectez-vous sans Single Sign On',
  'CO2 Reduction': 'Réduction des émissions de CO2',
  'Filter by rule': 'Filtrer par règle',
  Target: 'Cible',
  'Compressor Type': 'Type de compresseur',
  'Not Connected': 'Non connecté',
  'Keep Alive': 'Restez en vie',
  '9 to 13 digits are allowed': '9 à 13 chiffres sont autorisés',
  Notifications: 'Notifications',
  'Station Switch': 'Interrupteur de station',
  'Yearly View': 'Vue annuelle',
  Jan: 'Janv.',
  Feb: 'Févr.',
  Mar: 'Mar.',
  Apr: 'Avr.',
  May: 'Mai',
  Jun: 'Juin',
  Jul: 'Juill.',
  Aug: 'Août',
  Sep: 'Sept.',
  Oct: 'Oct.',
  Nov: 'Nov.',
  Dec: 'Déc.',
  Search: 'Rechercher',
  influentFlow: "Débit d'influent",
  dissolvedOxygen: 'Oxygène dissous',
  pH: 'pH',
  ammoniaAmmonium: 'Ammoniac (NH3) /Ammonium (NH4+)',
  nitrate: 'Nitrate (NO3-)',
  nitrite: 'Nitrite (NO2-)',
  oxidationReductionPotential: "Potentiel d'oxydoréduction",
  influentFlowSensor: 'Capteur $t(influentFlow)',
  dissolvedOxygenSensor: 'Capteur $t(dissolvedOxygen)',
  phSensor: 'Capteur $t(pH)',
  ammoniaAmmoniumSensor: 'Capteur $t(ammoniaAmmonium)',
  nitrateNO3Sensor: 'Capteur $t(nitrate)',
  nitriteNO2Sensor: 'Capteur $t(nitrite)',
  oxidationReductionPotentialSensor: 'Capteur $t(oxidationReductionPotential)',
  'm3/hour': 'm<0>3</0>/heure',
  GPM: 'GPM',
  blowerSpeed: 'Vitesse du ventilateur% (TR-MIN)',
  frequency: 'Fréquence',
  Hz: 'Hz',
  blower: 'Ventilateur',
  aerationBasin: "Bassin d'aération",
  'kWh/MG': 'kWh/MG',
  viewReport: 'Voir le rapport',

  // Station Parameters Tab
  validationForGreaterThan: '{{title}} doit être supérieur à {{min}} {{unit}}.',
  validationForMinTargetLessThanMaxTarget: 'La valeur minimale doit être inférieure à la valeur maximale.',
  validationForMinMax: '{{title}} doit être compris entre {{min}} et {{max}} {{unit}}.',
  targetPressure: 'Cible de pression',
  offsetFromTargetPressure: 'Plage morte par rapport à la pression cible dans laquelle équilibrer la charge',
  pressureForReloadingCompressor: 'Pression pour le rechargement d’un compresseur',
  pressureForStartingCompressor: 'Pression pour le démarrage d’un compresseur',
  pressureForEmergencyStart: 'Pression pour le démarrage d’urgence d’un compresseur',
  minLoadedCompressors: 'Nombre minimum de compresseurs chargés',
  engineRunIntervalsMinutes: 'Intervalles d’exécution de l’moteur (min)',
  pressureFactor: 'Décalage de pression pendant le test de décharge',
  minFrequency: 'Délai de tentative de décharge (min.)',
  minPressureSafetyMargin: 'Marge de sécurité de pression minimale (%)',
  minCompressorStartInterval: 'Intervalle de démarrage du compresseur minimal (min)',
  minCompressorRestartInterval: 'Intervalle de redémarrage du compresseur minimal (min)',
  flowPeakBuffer: 'Pic de débit',
  minIntervalHighFlowTrigger: 'Intervalle minimal à partir du déclencheur de débit élevé (min.)',
  setpointChangeInterval: 'Fréquence du décalage pendant le test de décharge (sec.)',
  kpiIntervalRetrieval: 'Intervalle KPI pour la récupération (min)',
  loadBalancingPressureFactor: "Décalage de pression pour l'équilibrage de charge",
  emergencyStartFrequency: 'Fréquence de démarrage d’urgence (min)',
  bovMin: 'Valeur moyenne minimale de la soupape BOV pour le test de décharge(%)',
  bovMax: 'Seuil de la soupape BOV pour décharger lors des tests(%)',
  fullLoadPressureBuffer: 'Marge de pression de pleine charge (%)',
  unloadTestingFlowBufferPercentage: 'Pourcentage du tampon de débit de test de décharge',
  searchStation: 'Rechercher une station',
  'Nothing to update. No changes were made to the information':
    'Aucune mise à jour. Aucun changement n’a été apporté à l’information',
  comments: 'Commentaires',
  provideReason: 'Veuillez fournir une raison',
  probabilityofreducingstationpressurebelowminimum:
    'Probabilité de réduire la pression de la station en dessous du minimum.',
  probabilityofreducingsavingsbelowthecommitment: "Probabilité de réduire les économies en dessous de l'engagement.",
  probabilityofharmingcompressorshealth:
    'Probabilité de nuire à la santé du compresseur - sélectionnez le compresseur.',
  probabilityofincreasingstationpressure: 'Probabilité d’augmenter la pression de la station.',
  edgecasenotproperlycovered: 'Les cas limites ne sont pas correctement couverts.',
  problematicFlowLevels: 'Niveaux de débit problématiques',
  problematicPressureRanges: 'Plages de pression problématiques',
  compressorRapidCycling: 'Cyclage rapide du compresseur',
  problematicSetpointsForCompressor: 'Points de consigne problématiques pour le compresseur',
  probabilityOfStationHighPressureValues: 'Probabilité des valeurs de haute pression de la station',
  extremeUsecasesAreNotProperlyCovered: "'Les cas d'utilisation extrêmes ne sont pas correctement couverts'",
  refreshEngine: 'Si vous avez mis à jour la version du moteur, actualisez pour modifier les paramètres',
  centrifugalStation1_0Notification:
    "Vous modifiez Engine 1.5, mais Engine 1.0 est actif. Les modifications ne seront appliquées qu'une fois Engine 1.5 activé dans Retool.",
  compressorSetpointsOrderInfo:
    "Les points de consigne du compresseur dans chaque tableau doivent refléter l'ordre attribué dans la colonne OR.",
  publishConfirmation: 'Toutes les configurations des onglets seront publiées. Confirmez pour continuer.',
  publishedOn: 'Publié le ',
  draftPublishedOn: 'Brouillon publié le ',
  incompleteStationParameters: 'Paramètres de station incomplets',
  incompleteCompressorParameters: 'Paramètres du compresseur incomplets',
  compressorParametersMissing: 'Certains paramètres du compresseur sont manquants.',
  stationParametersMissing: 'Certains paramètres de la station sont manquants.',
  errorSavingDraft: "Erreur lors de l'enregistrement du brouillon.",
  errorSavingDraftdesc: 'Veuillez remplir tous les champs requis pour les stations et les compresseurs.',
  success: 'succès',
  error: 'erreur',
  draftSaved: 'Brouillon enregistré avec succès.',
  draftSavedDesc: "Vos modifications sont enregistrées. N'oubliez pas de publier lorsque vous êtes prêt.",
  errorSavingChanges: "Une erreur s'est produite lors de l'enregistrement de vos modifications.",
  errorRevertLastPublished: 'Erreur lors du retour à la dernière version publiée',
  errorRevertLastPublishedDesc: "Une erreur s'est produite lors du retour à la dernière version publiée.",
  successPublish: 'Modifications publiées avec succès',
  successPublishDesc: 'Le contrôleur dynamique fonctionne désormais avec les paramètres publiés.',
  errorDraftPublish: 'Erreur lors de la publication du brouillon',
  errorDraftPublishDesc: "Une erreur s'est produite lors de la publication de vos modifications.",
  publishChanges: 'Publier les modifications',
  revertToLastPublished: 'Revenir à la dernière version publiée',
  confirmPublish: 'Confirmer la publication des modifications',
  publishChange: 'Publier la modification',
  reviewAgain: 'Revoir à nouveau',
  advancedSettings: 'Paramètres avancés',
  stopDelayMinutes: "Minutes de délai d'arrêt",
  maxFlow: 'Débit maximal',
  maxLoadAmps: 'Courant de charge maximal (A)',
  fiveLoop: '5 Boucle',
  noBaseline: 'Aucune ligne de base',
  noDefaultBaselineStrategy: "Aucune stratégie de base par défaut n'est disponible pour le moment",
  revertToDefaultBaselineStrategy:
    'Êtes-vous sûr de vouloir remplacer le brouillon existant par les configurations de base par défaut?',

  // Le Station Stage
  stationStageUpdating: 'Mise à jour de l’étape…',
  stationStageUpdated: 'L’étape a bien été mise à jour.',
  stationStageError: 'L’étape n’a pas été mise à jour. Veuillez réessayer.',
  stationStageDeprecateTitle: 'Déclarer la station comme obsolète',
  stationStageDeprecateWarning:
    'Vous êtes sur le point de déclarer cette station comme obsolète. Cette action entraînera plusieurs conséquences :',
  stationStageDeprecateConsequences1: 'Tous les paramètres système de la station seront désactivés.',
  stationStageDeprecateConsequences2: 'Aucune nouvelle mise à jour ou collecte de données ne sera effectuée.',
  stationStageDeprecateConsequences3: 'La station sera archivée à des fins de référence temporelle.',
  stationStageDeprecateConfirm: 'Voulez-vous vraiment continuer ? Cette action est irréversible.',
  stationStageDeprecateButton: 'Déclarer la station comme obsolète',
  stationStageCancelButton: 'Annuler',
  //instationvaldiation
  INSTALLATION_VALIDATION_TITLE: "Validation de l'installation",
  INSTALLATION_VALIDATION_SUBMITTED_TITLE: 'Validation déjà confirmée',
  INSTALLATION_VALIDATION_SUBMITTED_CONTENT:
    'Un autre utilisateur a déjà confirmé cette validation. Rafraichir pour voir le statut actuel.',
  INSTALLATION_VALIDATION_IN_PROGRESS_TITLE: 'Validation en cours',
  INSTALLATION_VALIDATION_IN_PROGRESS_CONTENT:
    'Un autre utilisateur à déjà démarré la validation. Rafraichir pour voir le statut actuel.',
  NOT_AVAILABLE: 'N/D',
  TESTING_IN_PROGRESS: 'Test en cours {{time}}',
  UNRESOLVED_COMPRESSORS_TITLE: 'États de compresseurs non résolus',
  UNRESOLVED_COMPRESSORS_DESC:
    "{{count}} compresseurs n'ont pas passé le test. Veuillez fournir un commentaire ou une raison pour chacun avant de soumettre le rapport",
  TEST_SUCCESS_TITLE: 'Test terminé avec succès',
  TEST_SUCCESS_DESC: 'Tous les états des compresseurs ont passé le test avec succès.',
  REPORT_SUBMIT_SUCCESS: 'Rapport soumis avec succès',
  REPORT_SUBMIT_ERROR: 'Échec de la soumission du rapport',
  LOAD_TEST: 'Test en charge',
  UNLOAD_TEST: 'Test à vide',
  PASSED: 'Réussi',
  FAILED: 'Échoué',
  TESTING: 'Test en cours...',
  NOT_TESTED: 'Non testé',
  NOT_STARTED: '',
  VIEW_COMMENT: 'Voir le commentaire',
  ADD_COMMENT: 'Ajouter un commentaire',
  NO_POWER_SENSOR: 'Pas de capteur de puissance',
  UNRESOLVED_COMPRESSORS_MESSAGE:
    "compresseurs n'ont pas passé le test. Veuillez fournir un commentaire ou une raison pour chacun avant de soumettre le rapport",
  SUBMIT_CONFIRMATION_MESSAGE:
    "En soumettant le rapport de test, vous indiquez que l'installation est terminée et prête pour révision",
  TEST_NOT_INITIATED_TITLE: "Le test n'a pas été lancé correctement",
  TEST_NOT_INITIATED_DESC: "Le test n'a pas été lancé correctement. Veuillez recommencer le test.",

  BACK_TO_LIST: 'Retour à la liste',
  TEST_AGAIN: 'Tester à nouveau',
  SUBMIT_REPORT: 'Soumettre le rapport',
  CANCEL: 'Annuler',
  'Flow sum': 'Somme des débits ',
  unresolvedCompressorStates: 'États de compresseurs non résolus',
  confirmSubmission: 'Confirmer la soumission',
  testCompletedSuccessfully: 'Test terminé avec succès',
  commentsInfo: 'Les commentaires ne seront sauvegardés que dans le rapport soumis.',
  comment: 'Commentaire',
  loadTestFailed: 'Test en charge échoué',
  unloadTestFailed: 'Test à vide échoué',
  loadTestNotTested: 'Test de charge non effectué',
  unloadTestNotTested: 'Test de décharge non effectué',
  flowTestFailed: 'Échec du test de débit',
  flowTestNotTested: 'Test de débit non effectué',
  okCamelCase: 'Ok',
  START_TEST: 'Démarrer le test',
  END_TEST: 'Terminer le test',
  TEST_DATE: 'Date du test: {{date}}',
  SAVE_CHANGES: 'Enregistrer les modifications',
  ADD: 'Ajouter',
  compressorMetrics: 'Métriques du compresseur',
  noMetricsAvailable: 'Aucune métrique disponible',
  loadBand1: 'Bande de charge 1',
  loadBand2: 'Bande de charge 2',
  unloadBand1: 'Bande de décharge 1',
  unloadBand2: 'Bande de décharge 2',
  sensorsKPIConfiguration: 'Configuration des capteurs KPI',
  flowSensorKPI: 'Capteur KPI de débit',
  pressureSensorKPI: 'Capteur KPI de pression',
  moreActions: 'Plus d’actions',
  StationStatus_Inactive: 'Le contrôleur dynamique est inactif',
  StationStatus_oneDotZeroActive: 'Le contrôleur dynamique 1.0 est activé',
  StationStatus_oneDotFiveActive: 'Le contrôleur dynamique 1.5 est activé',
  StationStatus_oneDotZeroUnderMaintenance: 'Le contrôleur dynamique 1.0 est désactivé - En cours de maintenance',
  StationStatus_oneDotFiveUnderMaintenance: 'Le contrôleur dynamique 1.5 est désactivé - En cours de maintenance',
  StationStatus_oneDotFiveActiveFallback: 'Le contrôleur dynamique 1.5 est activé',
  StationStatus_oneDotZeroDisabled: 'Le contrôleur dynamique 1.0 est désactivé',
  StationStatus_oneDotFiveDisabled: 'Le contrôleur dynamique 1.5 est désactivé',
  StationStatus_offline: 'Hors ligne',
  SelectReason: 'Sélectionnez une raison',
  revertConfirmation:
    'Vous demandez à remplacer la stratégie existante par la version {{version}}. En revenant à cette version, une nouvelle stratégie sera publiée et remplacera le brouillon existant. Voulez-vous continuer ?',

  // EPTable controls
  scrollToTop: 'Défiler vers le haut',
  scrollToBottom: 'Défiler vers le bas',
  showAllRows: 'Afficher toutes les lignes',
  showWithPagination: 'Afficher avec pagination',
  showLess: 'Afficher moins',
  showAll: 'Afficher tout',
  reason: 'Raison',
  dateTime: 'Date et heure',
  deactivatedBy: 'Désactivé par',
  deactivationReason: 'Raison de désactivation',
  viewReason: 'Voir la raison',
  confirmDeactivationTitle: 'Confirmer la désactivation et fournir la raison',
  deactivationContent:
    'La désactivation du contrôleur dynamique peut affecter le fonctionnement du système. Veuillez confirmer et indiquer la raison de la désactivation.',
  stopDelayMinutesEmptyMessage: 'Le délai d’arrêt ne peut pas être vide.',
  priorityEmptyMessage: 'La priorité ne doit pas être vide',
  priorityUniqueValueMessage: 'Chaque compresseur doit avoir une valeur de priorité unique',
  shouldNotBeEmpty: 'ne devrait pas être vide',
  maxTargetGreaterThanMinTarget: 'La cible maximale doit être supérieure à la cible minimale',
  minTargetLessThanMaxTarget: 'La cible minimale doit être inférieure à la cible maximale',

  //site survey form
  welcomeTitle: "Bienvenue à l'enquête sur le site",
  welcomeSteps: "Commencez par ajouter l'ID de compte Salesforce, puis suivez ces 3 étapes simples",
  accountPlaceholder: "Ajoutez l'ID de compte Salesforce",
  accountRequired: "Veuillez saisir l'ID de compte Salesforce",
  accountTooltip: "Ajoutez l'ID_18 depuis Salesforce",
  startButton: 'Allons-y',
  confirmCustomerDetails: 'Confirmer les détails du client',
  tierRequired: 'Veuillez sélectionner un niveau',
  selectTier: 'Sélectionner un niveau',
  siteAddress: 'Adresse du site',
  contactPerson: 'Personne de contact',
  edit: 'Modifier',
  associateWithCustomer: 'Associer au client Ecoplant (optionnel)',
  allocateStationDescription: 'Voulez-vous affecter cette station à un compte Ecoplant existant ?',
  selectAccount: 'Sélectionner un compte',
  continue: 'Continuer',
  'Salesforce account ID': 'ID de compte Salesforce',
  Monitor: 'Moniteur',
  Optimize: 'Optimiser',
  'Edit site address': "Modifier l'adresse du site",
  'This address will be used for the shipment of equipment':
    "Cette adresse sera utilisée pour l'expédition de l'équipement",
  'Street address': 'Adresse',
  City: 'Ville',
  State: 'État',
  'ZIP code': 'Code postal',
  'Please enter street address': "Veuillez saisir l'adresse",
  'Please enter city': 'Veuillez saisir la ville',
  'Please enter state': "Veuillez saisir l'état",
  'Please enter ZIP code': 'Veuillez saisir le code postal',
  'Please enter a valid ZIP Code': 'Veuillez saisir un code postal valide',
  'Save changes': 'Enregistrer les modifications',
  'Edit contact person': 'Modifier la personne de contact',
  'Full name': 'Nom complet',
  'Please enter full name': 'Veuillez saisir le nom complet',
  'Please enter email': "Veuillez saisir l'email",
  'Please enter a valid email address': 'Veuillez saisir une adresse email valide',
  'Please select a tier': 'Veuillez sélectionner un niveau',
  'No accounts available': 'Aucun compte disponible',
  'Welcome to the site survey': "Bienvenue à l'enquête de site",
  siteFormAlreadyExists: 'Une enquête de site existe déjà pour ce compte',
  canContinueEditing:
    'Vous pouvez continuer à le modifier ou en créer un nouveau. Créer un nouveau sondage remplacera celui existant et ne pourra pas être annulé.',
  availableSitesForm: 'Enquêtes de site disponibles',
  continueEditingForm: "Continuer l'édition",
  startNewSurvey: 'Démarrer une nouvelle enquête',
  'Easily configure a precise, customer-specific site map.':
    'Configurez facilement une carte de site précise et spécifique au client.',
  'Start by adding the Salesforce account ID then follow these 3 simple steps':
    "Commencez par ajouter l'identifiant de compte Salesforce puis suivez ces 3 étapes simples",
  'Add Salesforce account ID': "Ajouter l'identifiant de compte Salesforce",
  'Failed to fetch account data. Please try again.':
    'Échec de la récupération des données du compte. Veuillez réessayer.',
  'Cannot proceed: Missing Salesforce Account ID':
    'Impossible de continuer : Identifiant de compte Salesforce manquant',
  'Site configuration data may not be properly saved':
    'Les données de configuration du site peuvent ne pas être correctement enregistrées',
  'Failed to fetch model specifications. Some dropdown options may not be available.':
    'Échec de la récupération des spécifications du modèle. Certaines options des listes déroulantes peuvent ne pas être disponibles.',
  'Assets assignment data may not be properly saved':
    "Les données d'attribution des actifs peuvent ne pas être correctement enregistrées",
  'Assets assignment data saved successfully': "Données d'attribution des actifs enregistrées avec succès",
  'Failed to save assets assignment data. Please try again.':
    "Échec de l'enregistrement des données d'attribution des actifs. Veuillez réessayer.",
  customerInformationStepLabel: 'Confirmer les informations client',
  siteConfigurationStepLabel: 'Définir la configuration du site',
  roomConfigurationStepLabel: 'Attribuer les actifs',
  backButton: 'Retour',
  closeButton: 'Fermer',
  Continue: 'Continuer',
  'Create Station': 'Créer la station',
  'Please fix validation errors before submitting': 'Veuillez corriger les erreurs de validation avant de soumettre',
  'Define site configuration': 'Définir la configuration du site',
  'Number of compressor rooms': 'Nombre de salles de compresseurs',
  Other: 'Autre',
  'Number of production floors': 'Nombre de niveaux de production',
  'System controller type (If installed)': 'Type de contrôleur de système (si installé)',
  'Add system controller type': 'Ajouter le type de contrôleur de système',
  "Station's name": 'Nom de la station',
  'Is there more than 1 target pressure?': "Y a-t-il plus d'une pression cible ?",
  'What is the pressure at this station?': 'Quelle est la pression à cette station ?',
  'Note: Each pressure type requires a separate site survey':
    'Remarque : Chaque type de pression nécessite une enquête de site distincte',

  'Assets assignment': 'Attribution des actifs',
  Remove: 'Supprimer',
  'Compressors in this room': 'Compresseurs dans cette salle',
  'Select available compressors': 'Sélectionner les compresseurs disponibles',
  'Add manual compressor': 'Ajouter un compresseur manuellement',
  'This number is already in use': 'Ce numéro est déjà utilisé',
  'Serial number': 'Numéro de série',
  Model: 'Modèle',
  'Model spec': 'Spécification du modèle',
  Select: 'Sélectionner',
  Controller: 'Contrôleur',
  'Delete compressor': 'Supprimer le compresseur',
  'Add details for accurate setup': 'Ajouter des détails pour une configuration précise',
  'Tanks in the room': 'Réservoirs dans la salle',
  'Select Type': 'Sélectionner le type',
  'Add another tank': 'Ajouter un autre réservoir',
  'Add room': 'Ajouter une salle',
  'Define Site Configuration': 'Définir la configuration du site',
  'Each compressor must have a unique number': 'Chaque compresseur doit avoir un numéro unique',
  'Each room must have at least one compressor': 'Chaque salle doit avoir au moins un compresseur',
  compressorRooms: 'Salles de compresseurs',
  pressureType: 'Type de pression',
  low: 'Basse',
  medium: 'Moyenne',
  high: 'Haute',
  'Assets Assignment': 'Attribution des actifs',
  'Compressor number is required': 'Le numéro de compresseur est requis',
  createNewSite: "Créer ou modifier l'enquête de site",
  welcomeDescription:
    "Configurez une carte de site précise et spécifique au client. Entrez l'ID de compte Salesforce pour commencer une nouvelle enquête ou poursuivre une enquête existante.",
  lit: 'Lit',
  'Please enter valid ZIP code': 'Veuillez saisir un code postal valide',
  'Please enter only numbers': 'Veuillez saisir uniquement des chiffres',
  'Progress saved successfully.': 'Progression enregistrée avec succès.',
  'Failed to save progress. Please try again.': "Échec de l'enregistrement de la progression. Veuillez réessayer.",

  stationParameters: 'Paramètres de la station',
  compressorParameters: 'Paramètres du compresseur',
  required: 'Requis',
  errorSavingEngineConfig:
    'Une erreur est survenue lors de l’enregistrement de la configuration du moteur. Veuillez réessayer plus tard.',
  maxTarget: 'Cible max.',
  minTarget: 'Cible min.',
  priority: 'Priorité',
  timeBetweenUnoadingStop: 'Temps entre le déchargement et l’arrêt (en min.)',
  'EcoPlant 2025. All right reserved.': 'EcoPlant 2025. Tous droits réservés.',
  OFFERING: 'offre',
  SETTINGS: 'paramètres',
  stationStageNoStageSelected: 'Aucune étape sélectionnée',
  stationStageMoveTo: 'Déclarer comme',
  stationStageState: 'État',
  stationStageStatus: 'Statut de la station',
  SPILL_VALVE_HP_LOW_LIMIT_SETPOINT: 'Limite de la consigne cible de la valve de déversement HP inférieure',
  SPILL_VALVE_HIGH_PRESSURE: 'Pression de la valve de déversement haute',
  SPILL_VALVE_LOW_PRESSURE: 'Pression de la valve de déversement basse',
  SPILL_VALVE_LP_TARGET_SETPOINT: 'Objectif de la consigne cible de la valve de déversement LP',
  CURRENT_VALVE_POSITION: 'Position actuelle de la valve',
  theme: 'Thème',
  dark: 'Sombre',
  light: 'Clair',
  measurementSystem: 'Unité de mesure',
  en: 'Anglais',
  fr: 'Français',
  de: 'Allemand',
  metric: 'Métrique',
  imperial: 'Impériale',

  measuredLeak: 'Mesuré',
  leakMeasureFlow: '% Débit',
  leakProductionFlow: '% prod. flux',

  leakageCreatedNotificationMessage: "Avertit lorsqu'un nouvel événement de fuite est créé",
  activateDynamicControllerMessage: 'Êtes-vous sûr de vouloir activer le contrôleur dynamique ?',
  activate: 'Activer',
  activateDynamicController: 'Activer le contrôleur dynamique',
  'Dryers in the room': 'Sèche-cheveux dans la salle',
  'Add another dryer': 'Ajouter un autre sèche-cheveux',
  stationControlDefaultSetpointsBaseline:
    'Vous êtes sur le point de désactiver le Contrôleur Dynamique Ecoplant. La station reviendra aux points de consigne de référence. Veuillez confirmer et indiquer la raison de la désactivation.',
  stationControlDefaultSetpointsCustom:
    'Vous êtes sur le point de désactiver le Contrôleur Dynamique Ecoplant. La station reviendra aux points de consigne personnalisés. Veuillez confirmer et indiquer la raison de la désactivation.',
  'Spec data': 'Données spécifiques',
  Edit: 'Modifier',
  Platform: 'Plateforme',
  'Cooling type': 'Type de refroidissement',
  'URL to compressor model spec': 'URL vers la spécification du modèle de compresseur',
  'Add information for setup of': 'Ajouter des informations pour la configuration de',
  'Enter value': 'Entrer une valeur',
  Horsepower: 'Puissance',
  Cooling: 'Refroidissement',
  Type: 'Type',
  'Have a spec URL instead?': 'Avez-vous une URL de spécification à la place ?',
  'Add spec link instead': 'Ajouter une URL de spécification à la place',
  'Paste link to spec': "Coller l'URL de spécification",
  "Don't have a URL?": "N'avez-vous pas d'URL ?",
  'Enter details manually': 'Entrer les détails manuellement',
  'Select manufacturer': 'Sélectionner le fabricant',
  serialNumber: 'Numéro de série',
  'Additional compressors': 'Compresseurs supplémentaires',
  'Please enter a valid URL': 'Veuillez entrer une URL valide',
  userUnitOfMeasure: "Unité de mesure de l'utilisateur",
  'Units are in bar, do you want to continue?': 'Les unités sont en bar, voulez-vous continuer ?',
  'Drive Type': 'Type de moteur',
  // Engine Validation Modal
  engineValidationTitle: "Validation de l'état du moteur",
  engineValidationMessage:
    "Vous ne pouvez pas modifier l'état de la station depuis l'état Abonnement tant que le moteur est actif. Veuillez désactiver le moteur avant de modifier l'état de la station.",
  flowlevels: 'Niveaux de débit',
  pressureranges: 'Plages de pression',
  wrongcompressorcombinations: 'Mauvaise combinaison de compresseurs - Sélectionner une table',
  pressuredrop: 'Chute de pression - Sélectionner une table',
  setpointsforcompressor: 'Points de consigne pour le compresseur - sélectionner un compresseur + une table',
  fallbackcoverage: 'Couverture de secours',
  'Edit Map': 'Modifier la carte',
  'Exit Edit Mode': 'Quitter le mode édition',
  'Exit & Save Draft': 'Quitter & Enregistrer le brouillon',
  'Exit & Discard': 'Quitter & Rejeter',
  'Last Updated': 'Dernière mise à jour',
  April: 'Avril',
  'Save Changes': 'Enregistrer les modifications',
  'Click a pipe to add sensors/filters/valves.':
    'Cliquer sur une tuyauterie pour ajouter des actifs. Cliquer droit sur les capteurs, filtres ou vannes pour modifier.',
  'Select Model': 'Sélectionner le modèle',
  'Select Controller': 'Sélectionner le contrôleur',
  'No Controller': 'Aucun contrôleur',
  possiblecause: 'Cause possible :',
  selecttables: 'Sélectionner les tableaux',
  selectReasonError: 'Veuillez sélectionner une raison du rejet',
  selectCauseError: 'Veuillez sélectionner une cause possible du rejet',
  selectCompressorError: 'Veuillez sélectionner au moins un compresseur pour la raison',
  selectCompressorCauseError: 'Veuillez sélectionner au moins un compresseur pour la cause possible',
  selectTableError: 'Veuillez sélectionner au moins une table',
  commentLengthError: 'Le commentaire doit contenir entre 2 et 200 caractères',
  causeCommentLengthError: 'Le commentaire de la cause possible doit contenir entre 2 et 200 caractères',
  searchByNumber: 'Rechercher par numéro',
  selectAtleastOneCompressor: 'Veuillez sélectionner au moins un compresseur pour la panne du compresseur.',
  flowKPIOrPressureKPI: 'KPI de flux ou KPI de pression',
  compressorFailure: 'Panne du compresseur',
  appliedFilters: 'Filtres appliqués',
  scenario: 'Scénario',
  scenarioName: 'Nom du scénario',
  selectScenario: 'Sélectionner un scénario',
  selectCompressors: 'Sélectionner des compresseurs',
  ignoreFallbackCompressors: 'Compresseurs exclus de la génération de scénarios de secours',
  ignoreFallbackCompressorsTooltip:
    "Les scénarios de secours sont générés uniquement pour un ensemble défini de compresseurs. Cet ensemble est déterminé par l'intersection de :",
  ignoreFallbackCompressorsTooltipBullet1: 'Compresseurs actuellement disponibles dans le système',
  ignoreFallbackCompressorsTooltipBullet2: "Compresseurs non inclus dans la liste d'exclusion.",
  ignoreFallbackCompressorsTooltipNote:
    "Les compresseurs listés ici sont intentionnellement ignorés par la stratégie de secours—par exemple, parce qu'ils sont connus pour être déconnectés ou parce qu'aucun secours n'est requis s'ils échouent.",
  saveScenario: 'Enregistrer',
  newFallbackScenario: 'Nouveau scénario de secours',
  createACustomTable: 'Créer une table personnalisée',
  useExistingTable: 'Utiliser une table existante',
  createANewFallbackScenario: 'Créer un nouveau scénario de secours',
  pickOneToBuildOnEitherReuseAnExistingTableOrLetTheEngineSuggestASmartStartingPoint:
    'Choisissez-en un pour commencer. Réutilisez une table existante ou laissez le moteur suggérer un point de départ intelligent.',
  selectATableNumber: 'Sélectionner un numéro de table',
  filterFailScenario: 'Filtrer le scénario d’échec',
  refineScenariosByKPIAndComponents: 'Affiner les scénarios par indicateurs et composants',
  validationError: 'Erreur de validation',
  baseFallbackOnTable: 'Basé sur la table de secours',
  AND: 'ET',
  scenarioBasedOn: 'Scénario basé sur',
  failureOf: 'Panne de',
  flowKPIOrPressureKPIFailure: 'Échec du KPI de flux ou KPI de pression',
  newFallback: 'Nouveau secours',
  currentlyActive: 'Actuellement actif',
  view: 'Voir',
  removeScenario: 'Supprimer',
  updateScenario: 'Mettre à jour',
  firstApplyFiltersToDefineYourScenario: "Appliquez d'abord des filtres pour définir votre scénario",
  applyFiltersAndContinue: 'Appliquer les filtres et continuer',
  fallbackScenarioSavedSuccessfully: 'Scénario de secours enregistré avec succès',
  thisScenarioAlreadyExists: 'Ce scénario existe déjà.',
  confirmSaveScenario:
    'Enregistrement du scénario de secours, ce sera automatiquement mis à jour. Êtes-vous sûr de vouloir enregistrer ce scénario ?',
  confirmUpdateScenario:
    'Mise à jour du scénario de secours, ce sera automatiquement mis à jour. Êtes-vous sûr de vouloir mettre à jour ce scénario ?',
  confirmRemoveScenario:
    'Suppression du scénario de secours, ce sera automatiquement mis à jour. Êtes-vous sûr de vouloir supprimer ce scénario ?',
  fallbackScenario: 'Secours',
  flowKPI: 'KPI de flux',
  pressureKPI: 'KPI de pression',
  invalidScenario:
    'Scénario invalide comme Panne du compresseur, Échec du KPI de flux ou KPI de pression ne peuvent pas être appliqués ensemble.',
  regionRequired: 'La région est requise',
  set0ForACompressor: 'Establecer 0 para un compresor {}',
  trimmer: 'recortadora',
  setNegativeValueForCompressorsNotToBeIncluded:
    'Establezca un valor negativo para los compresores {} que se incluirán',
  not: 'no',
  setPositiveValueForCompressors: 'Establezca un valor positivo para los compresores {}',
  base: 'base',
  orderIsRequired: "L'ordre est requis",
  atLeastOneSetpointMustHavePositiveOrder: 'Au moins un point de consigne doit avoir un ordre positif',
  mixedStationNotSupported: 'Le moteur 1.5 ne prend actuellement pas en charge les stations mixtes',
  'Station design readiness': 'Préparation de la conception de la station',
  'Show missing data': 'Afficher les données manquantes',
  'Model specs missing': 'Spécifications du modèle manquantes',
  'Missing specs info': 'Informations de spécifications manquantes',
  'Missing Info': 'Informations manquantes',
  comps: 'comps',
  Missing: 'Manquant',
  images: 'images',
  'Add model spec': 'Ajouter des spécifications de modèle',
  'Add images': 'Ajouter des images',
  'Missing data & image': 'Données et image manquantes',
  sensor: 'capteur',
  'Add data': 'Ajouter des données',
  missingSpec: 'Données manquantes,',
  'Add a link to document': 'Ajouter un lien vers le document',
  'Add a link to presentation': 'Ajouter un lien vers la présentation',
  'Add a link to report': 'Ajouter un lien vers le rapport',
  'Add link to SCC activity log screenshot': "Ajouter un lien vers la capture d'écran du journal d'activité SCC",
  'More than one tracking number can be added.': "Plus d'un numéro de suivi peut être ajouté.",
  'More than one order number can be added.': "Plus d'un numéro de commande peut être ajouté.",
  'Engine version is set by engine expert': "La version du moteur est définie par l'expert moteur",
  Skip: 'Passer',

  // Report Tab Page
  reportDetails: 'Détails du rapport',
  dateCreated: 'Date de création',
  createdBy: 'Créé par',
  status: 'État',
  totalReports: 'Rapport',
  createNewReport: 'Créer un nouveau rapport',
  searchByDateCreatorOrStatus: 'Rechercher par date, créateur ou état',
  inProgress: 'En cours',
  failed: 'Erreur',
  inDraft: 'Brouillon',
  unknown: 'Inconnu',
  failedToDownloadReportFile: 'Échec du téléchargement du fichier de rapport',
  downloadingFile: 'Téléchargement du fichier...',
  fileDownloaded: 'Fichier téléchargé avec succès',
  deleteReport: 'Supprimer le rapport',
  areYouSureYouWantToDeleteThisReport: 'Êtes-vous sûr de vouloir supprimer ce rapport?',
  reportDeletedSuccessfully: 'Rapport supprimé avec succès',
  failedToDeleteReport: 'Échec de la suppression du rapport',
  failedToUploadReport: 'Échec du téléchargement du rapport',
  reportUploadedSuccessfully: 'Rapport téléchargé avec succès',
  anErrorOccurred: "Une erreur s'est produite",
  onlyPowerPointFilesAllowed: 'Seuls les fichiers PowerPoint (.pptx, .ppt) sont autorisés',
  pleaseSelectADateRange: 'Veuillez sélectionner une plage de dates',
  reportRequestedSuccessfully:
    "La génération du rapport peut prendre jusqu'à 15 minutes. Une fois terminée, l'état sur cette écran changera en Brouillon et les actions Modifier et Publier seront activées.",
  failedToRequestReport: 'Échec de la demande de génération de rapport',
  selectDates: 'Sélectionner les dates',
  noteForReportGeneration:
    'Remarque: La génération du rapport peut prendre quelques minutes. Vous serez averti par e-mail une fois terminé.',
  reportTimeFrameUpTo2Weeks: "La période du rapport peut aller jusqu'à 2 semaines.",
  generateReport: 'Générer le rapport',
  reportPublishedSuccessfully: 'Rapport publié avec succès',
  failedToPublishReport: 'Échec de la publication du rapport',
  addBusinessImpactBeforePublishing: "Ajouter l'impact commercial avant la publication",
  pleaseEstimateItsPotentialBusinessImpact:
    'Veuillez estimer son impact commercial potentiel. Cela aide à communiquer la valeur du rapport à votre client.',
  estimatedValue: 'Valeur estimée ($)',
  valueIsRequiredAndMustBeHigherThan0ToPublish: 'La valeur est requise et doit être supérieure à 0 pour publier',
  noteOncePublishedThisReportWillBeAutomaticallySharedWithAllRecipients:
    'Remarque: Une fois publié, ce rapport sera automatiquement partagé avec tous les destinataires.',
  publishReport: 'Publier le rapport',
  Upload: 'Télécharger',
  View: 'Voir',
  seeTheFullPictureOfYourReportPerformance: "Voir l'image complète de la performance de votre rapport",
  createAToTrackAnalyzeAndSharePerformance: 'Créer un rapport pour suivre, analyser et partager les performances',
  tryNewReport: 'Essayer un nouveau rapport',
  loadingReports: 'Chargement des rapports...',
  generatingReports: 'Génération des rapports...',
  noReportsAvailable: 'Aucun rapport disponible',
  sentForPublishing: 'Envoyé pour publication',
  kpiChanges:
    'Une nouvelle stratégie de moteur doit être définie et publiée puisque la configuration des KPI des capteurs a été modifiée. Veuillez examiner les modifications et publier la configuration.',
  kpiChangesAndPIDChanges:
    'Une nouvelle stratégie de moteur doit être définie et publiée puisque la configuration des KPI des capteurs et du P&ID de la station a changé. Vous trouverez ci-dessous la liste des actifs qui affectent la stratégie de contrôle:',
  dynamicControlInvalidStationStage:
    "Le contrôle dynamique ne peut pas être activé car la station n'est pas à l'étape d'Abonnement/Préparation de contrôle.",
  fallbackScenarioForAllCompressorsFailureCannotBeDefined:
    'Un scénario de secours pour toutes les pannes de compresseurs ne peut pas être défini',
  reportPublishedInProgress:
    "La publication du rapport peut prendre quelques minutes. Une fois terminée, l'état sur cette écran changera en Publié, l'action Voir sera activée et le client pourra voir ce rapport.",
  loadingDocument: 'Chargement du document...',
};

export default fr;
